/*!
 * froala_editor v4.6.2 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], t) : t(e.FroalaEditor);
}(this, function (je) {
  "use strict";

  function n(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var a = 0, l = Array(t); a < t; a++) l[a] = e[a];
    return l;
  }
  function Ge(e) {
    return function t(e) {
      if (Array.isArray(e)) return n(e);
    }(e) || function a(e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function l(e, t) {
      if (e) {
        if ("string" == typeof e) return n(e, t);
        var a = {}.toString.call(e).slice(8, -1);
        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? n(e, t) : void 0;
      }
    }(e) || function r() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  je = je && je.hasOwnProperty("default") ? je["default"] : je, Object.assign(je.POPUP_TEMPLATES, {
    "table.insert": "[_BUTTONS_][_ROWS_COLUMNS_]",
    "table.edit": "[_BUTTONS_]",
    "table.colors": "[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]",
    "table.cellProperties": "[_CELL_PROPERTIES_FORM_][_BUTTONS_]",
    "table.tableProperties": "[_TABLE_PROPERTIES_FORM_][_BUTTONS_]"
  }), Object.assign(je.DEFAULTS, {
    tableInsertMaxSize: 10,
    tableEditButtons: ["tableHeader", "tableFooter", "tableRemove", "tableRows", "tableColumns", "tableProperties", "-", "tableCells", "tableCellProperties", "tableCellVerticalAlign", "tableCellHorizontalAlign", "tableCellStyle"],
    tableInsertButtons: ["tableBack", "|"],
    tableResizer: !0,
    tableDefaultWidth: "50%",
    tableDefaultAlign: "center",
    tableDefaultHeight: "100px",
    tableDefaultBGColor: "",
    tableDefaultBorderColor: "",
    tableDefaultBorderWidth: "1px",
    tableDefaultBorderStyle: "solid",
    tableBorderStyle: ["solid", "dashed", "dotted", "double", "groove", "ridge", "inset", "outset"],
    tableResizerOffset: 5,
    tableResizingLimit: 30,
    tableColorsButtons: ["tableBack", "|"],
    tableColors: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    tableColorsStep: 7,
    tableCellStyles: {
      "fr-highlighted": "Highlighted",
      "fr-thick": "Thick"
    },
    tableStyles: {
      "fr-dashed-borders": "Dashed Borders",
      "fr-alternate-rows": "Alternate Rows"
    },
    tableCellMultipleStyles: !0,
    tableMultipleStyles: !0,
    tableInsertHelper: !0,
    keepTextFormatOnTable: !1,
    tableInsertHelperOffset: 15,
    proportionalTableResize: !0,
    enableTableSelection: !0
  }), je.PLUGINS.table = function (Y) {
    var W,
      c,
      p,
      b,
      l,
      f,
      h,
      u,
      g,
      Z = Y.$,
      i = !1,
      s = {};
    function C() {
      var e = j();
      if (e) {
        var t = Y.popups.get("table.edit");
        if (t || (t = o()), t) {
          Y.popups.setContainer("table.edit", Y.$sc);
          var a = _(e),
            l = a.left + (a.right - a.left) / 2,
            r = a.bottom;
          Y.popups.show("table.edit", l, r, a.bottom - a.top, !0), Y.edit.isDisabled() && (Y.$el.removeClass("fr-no-selection"), Y.edit.on(), Y.button.bulkRefresh(), Y.selection.setAtEnd(Y.$el.find(".fr-selected-cell").last().get(0)), Y.selection.restore());
        }
      }
    }
    function r() {
      0 === ge().length && Y.toolbar.enable();
    }
    function n(e) {
      if (e) return Y.popups.onHide("table.insert", function () {
        Y.popups.get("table.insert").find('.fr-table-size .fr-select-table-size > span[data-row="1"][data-col="1"]').trigger("mouseover");
      }), !0;
      var t = "";
      0 < Y.opts.tableInsertButtons.length && (t = '<div class="fr-buttons fr-tabs">'.concat(Y.button.buildList(Y.opts.tableInsertButtons), "</div>"));
      var a = {
          buttons: t,
          rows_columns: function n() {
            for (var e = '<div class="fr-table-size"><div class="fr-table-size-info">1 &times; 1</div><div class="fr-select-table-size">', t = 1; t <= Y.opts.tableInsertMaxSize; t++) {
              for (var a = 1; a <= Y.opts.tableInsertMaxSize; a++) {
                var l = "inline-block";
                2 < t && !Y.helpers.isMobile() && (l = "none");
                var r = "fr-table-cell ";
                1 == t && 1 == a && (r += " hover"), e += '<span class="fr-command '.concat(r, '" tabIndex="-1" data-cmd="tableInsert" data-row="').concat(t, '" data-col="').concat(a, '" data-param1="').concat(t, '" data-param2="').concat(a, '" style="display: ').concat(l, ';" role="button"><span></span><span class="fr-sr-only">').concat(t, " &times; ").concat(a, "&nbsp;&nbsp;&nbsp;</span></span>");
              }
              e += '<div class="new-line"></div>';
            }
            return e += "</div></div>";
          }()
        },
        l = Y.popups.create("table.insert", a);
      return Y.events.$on(l, "mouseover", ".fr-table-size .fr-select-table-size .fr-table-cell", function (e) {
        d(Z(e.currentTarget));
      }, !0), function r(e) {
        Y.events.$on(e, "focus", "[tabIndex]", function (e) {
          var t = Z(e.currentTarget);
          d(t);
        }), Y.events.on("popup.tab", function (e) {
          var t = Z(e.currentTarget);
          if (!Y.popups.isVisible("table.insert") || !t.is("span, a")) return !0;
          var a,
            l = e.which;
          if (je.KEYCODE.ARROW_UP == l || je.KEYCODE.ARROW_DOWN == l || je.KEYCODE.ARROW_LEFT == l || je.KEYCODE.ARROW_RIGHT == l) {
            if (t.is("span.fr-table-cell")) {
              var r = t.parent().find("span.fr-table-cell"),
                n = r.index(t),
                o = Y.opts.tableInsertMaxSize,
                i = n % o,
                s = Math.floor(n / o);
              je.KEYCODE.ARROW_UP == l ? s = Math.max(0, s - 1) : je.KEYCODE.ARROW_DOWN == l ? s = Math.min(Y.opts.tableInsertMaxSize - 1, s + 1) : je.KEYCODE.ARROW_LEFT == l ? i = Math.max(0, i - 1) : je.KEYCODE.ARROW_RIGHT == l && (i = Math.min(Y.opts.tableInsertMaxSize - 1, i + 1));
              var c = s * o + i,
                f = Z(r.get(c));
              d(f), Y.events.disableBlur(), f.focus(), a = !1;
            }
          } else je.KEYCODE.ENTER == l && (Y.button.exec(t), a = !1);
          return !1 === a && (e.preventDefault(), e.stopPropagation()), a;
        }, !0);
      }(l), l;
    }
    function d(e) {
      var t = e.data("row");
      null !== t && (t = parseInt(t));
      var a = e.data("col");
      null !== a && (a = parseInt(a));
      var l = e.parent();
      l.siblings(".fr-table-size-info").html("".concat(t, " &times; ").concat(a)), l.find("> span").removeClass("hover fr-active-item");
      for (var r = 1; r <= Y.opts.tableInsertMaxSize; r++) for (var n = 0; n <= Y.opts.tableInsertMaxSize; n++) {
        var o = l.find('> span[data-row="'.concat(r, '"][data-col="').concat(n, '"]'));
        r <= t && n <= a ? o.addClass("hover") : r <= t + 1 || r <= 2 && !Y.helpers.isMobile() ? o.css("display", "inline-block") : 2 < r && !Y.helpers.isMobile() && o.css("display", "none");
      }
      e.addClass("fr-active-item");
    }
    function o(e) {
      if (e) return Y.popups.onHide("table.edit", r), !0;
      if (0 < Y.opts.tableEditButtons.length) {
        var t = {
            buttons: '<div class="fr-buttons">'.concat(Y.button.buildList(Y.opts.tableEditButtons), "</div>")
          },
          a = Y.popups.create("table.edit", t);
        return Y.events.$on(Y.$wp, "scroll.table-edit", function () {
          Y.popups.isVisible("table.edit") && C();
        }), a;
      }
      return !1;
    }
    function T(e, t, a) {
      var l = Z(e),
        r = Z(t);
      a && "REMOVE" !== a && "transparent" !== a && "rgba(0, 0, 0, 0)" !== a ? (l.css("background-color", a), r.css("display", "none")) : (l.css("background-color", "transparent"), r.css("display", "block"));
    }
    function m() {
      var e = Y.popups.get("table.cellProperties");
      if (!e) {
        e = Y.popups.create("table.cellProperties", {
          cell_properties_form: '\n          <div class="fr-cell-properties-form">\n            <div class="fr-cell-properties-section">\n              <label>Background</label>\n              <div class="fr-cell-bg-container">\n                <input type="text" id="fr-cell-bg" class="fr-input" tabIndex="1" placeholder="Color">\n                <button type="button" class="fr-command fr-btn-cell-bg-color" tabIndex="2" data-param1="cell" data-cmd="openColorPicker">\n                  <div class="fr-color-preview">\n                    <div class="fr-color-preview-indicator"></div>\n                  </div>\n                </button>\n              </div>\n            </div>\n        \n            <div class="fr-cell-dimensions-container">\n              <div class="fr-cell-dimension-section">\n                <label>Dimensions</label>\n                <div class="fr-dimension-inputs">\n                  <input type="text" id="fr-cell-width" tabIndex="3" placeholder="Width">\n                  <span class="fr-dimension-separator">\xd7</span>\n                  <input type="text" id="fr-cell-height" tabIndex="4" placeholder="Height">\n                  <label for="fr-cell-height"></label>\n                </div>\n              </div>\n        \n              <div class="fr-cell-padding-section">\n                <label>Padding</label>\n                <div>\n                  <input type="text" id="fr-cell-padding" tabIndex="5" placeholder="Size">\n                  <label for="fr-cell-padding"></label>\n                </div>\n              </div>\n            </div>\n        \n            <div class="fr-cell-properties-buttons">\n              <button type="button" class="fr-command fr-enable-accessibility fr-cancel-button" tabIndex="6" data-cmd="onCancel">Cancel</button>\n              <button type="button" class="fr-command fr-enable-accessibility fr-save-button" tabIndex="7" data-cmd="applyCellProperties">Save</button>\n            </div>\n          </div>',
          buttons: ""
        }), w(), Y.events.$on(e, "input", "#fr-cell-bg", function () {
          e.data("bg-modified", !0);
        }), Y.events.$on(e, "input", "#fr-cell-width", function () {
          e.data("width-modified", !0);
        }), Y.events.$on(e, "input", "#fr-cell-height", function () {
          e.data("height-modified", !0);
        }), Y.events.$on(e, "input", "#fr-cell-padding", function () {
          e.data("padding-modified", !0);
        });
      }
      return e;
    }
    function w() {
      var e = Y.popups.get("table.cellProperties");
      e && (e.data("bg-modified", !1), e.data("width-modified", !1), e.data("height-modified", !1), e.data("padding-modified", !1));
    }
    function v(e) {
      var t,
        a,
        l,
        r,
        n = Y.popups.get("table.colors").data("type");
      if ("table" === n) {
        var o = Y.popups.get("table.tableProperties");
        t = o.find(".fr-color-preview"), a = o.find(".fr-color-preview-indicator"), l = o.find("#fr-table-bg");
      } else if ("cell" === n) {
        var i = Y.popups.get("table.cellProperties");
        t = i.find(".fr-color-preview"), a = i.find(".fr-color-preview-indicator"), l = i.find("#fr-cell-bg"), r = Y.popups.get("table.cellProperties");
      } else if ("border" === n) {
        var s = Y.popups.get("table.tableProperties");
        t = s.find(".fr-border-color-preview"), a = s.find(".fr-border-color-preview-indicator"), l = s.find("#fr-table-border-color");
      }
      "string" == typeof e && (Y.helpers.isRGBColor(e) && (e = Y.helpers.RGBToHex(e).toUpperCase()), (Y.helpers.isValidHexColor(e) || "transparent" === e || "" === e) && (Z(l).val(e), Z(l).focus(), "cell" === n && Z(r).data("bg-modified", !0), T(t, a, e)));
    }
    function y(e) {
      var t = Y.doc.createRange(),
        a = e.get(0).querySelector("td, th");
      t.setStart(a, 0), t.collapse(!0);
      var l = Y.selection.get();
      l.removeAllRanges(), l.addRange(t);
    }
    function e() {
      s[Y.id] || (s[Y.id] = Z(document.createElement("div")).attr("class", "fr-table-selector").html('<a role="button" tabIndex="-1" title="'.concat(Y.language.translate("Select Table"), '">').concat(Y.icon.create("tableSelectorIcon"), "</a>")));
      var n = Y.language.translate("The content you are pasting does not contain a table.\nPlease ensure the copied content is in table format.");
      Y.events.on("paste.before", function (e, t) {
        if (Y.popups.hideAll(), Y.$el.find("table.fr-table-selected").length) {
          var a = t || e && e.clipboardData;
          if (a && a.items) {
            var l = (a || window.clipboardData).getData("text/html") || "";
            if (!l || -1 === l.indexOf("<table")) return alert(n), e.preventDefault(), e.stopPropagation(), !1;
          }
        }
        return !0;
      }), Y.events.on("html.beforeInsert", function (e) {
        if (!g) {
          var t = Y.$el.find("table.fr-table-selected"),
            a = ge();
          if (a.length && !t.length && e.startsWith("<table") && (t = Z(a[0].closest("table"))), !t.length || i) return !0;
          var l = function r(e) {
            var t = Y.doc.createElement("div");
            t.innerHTML = e;
            for (var a = t.firstChild; a;) {
              var l = a.nextSibling;
              (a.nodeType === Node.TEXT_NODE && "" === a.textContent.replace(/\u200b/g, "").trim() || a.nodeType === Node.COMMENT_NODE || "SPAN" === a.tagName && "" === a.textContent.replace(/\u200b/g, "").trim()) && a.remove(), a = l;
            }
            return 1 === t.childNodes.length && "TABLE" === t.childNodes[0].tagName && t.childNodes[0];
          }(e);
          return l ? (function u(e, t) {
            for (var a = t.get(0), l = ge().length ? ge()[0] : a.rows[0].cells[0], r = l && l.parentNode ? l.parentNode.rowIndex : 0, n = l ? l.cellIndex : 0, o = a.rows, i = e.rows, s = 0; s < i.length; s++) {
              if (!o[r + s]) for (var c = o[o.length - 1].cells.length, f = a.insertRow(), d = 0; d < c; d++) f.insertCell();
              for (var p = o[r + s], b = function b() {
                  if (!p.cells[n + h]) for (var e = 0; e < o.length; e++) o[e].insertCell();
                  var t = p.cells[n + h],
                    a = i[s].cells[h];
                  t.outerHTML = a.outerHTML;
                  var l = o[r + s].cells[n + h];
                  setTimeout(function () {
                    Y.events.trigger("cell.replaced", [t, l]);
                  }, 10);
                }, h = 0; h < i[s].cells.length; h++) b();
            }
            return !0;
          }(l, t) && setTimeout(function () {
            Y.$el.find(".fr-selected-cell").removeClass("fr-selected-cell");
            var e = Y.snapshot.get();
            Y.undo_stack[Y.undo_index - 1] = e;
          }, 20), Y.keys.positionCaret(), Y.popups.hideAll(), Y.events.trigger("html.inserted")) : alert(n), !1;
        }
        g = !1;
      }), Y.events.on("mousedown", function () {
        Y.$el.find("table.fr-table-selected").length && oe();
      }), Y.events.$on(Z(Y.o_win), "resize", function () {
        var e = Y.$el.find("table.fr-table-selected");
        e.length ? ie(e) : oe();
      }), Y.events.on("commands.undo commands.redo commands.before", function (e) {
        if (!/^align/.test(e)) {
          var t = Y.$el.find("table.fr-table-selected");
          t.length && (oe(), y(t));
        }
      });
      var e = null,
        t = null;
      Y.events.on("snapshot.before", function () {
        t = Y.$el.find("table.fr-table-selection-hover"), e = Y.$el.find("table.fr-table-selected"), re(t, "fr-table-selection-hover"), re(e, "fr-table-selected");
      }), Y.events.on("snapshot.after", function () {
        e && e.addClass("fr-table-selected"), t && t.addClass("fr-table-selection-hover");
      }), Y.events.$on(s[Y.id], "click", function () {
        var e = Y.$el.find("table.fr-table-selection-hover"),
          t = Y.$el.find("table.fr-table-selected");
        e.length && (re(t, "fr-table-selected"), s[Y.id].addClass("fr-table-selector-active-selected"), e.addClass("fr-table-selected"), re(e, "fr-table-selection-hover"), t = e);
        var a = Y.doc.createRange();
        Y.selection.get().removeAllRanges();
        var l = t.get(0);
        a.selectNode(l), Y.selection.get().addRange(a), s[Y.id].attr("draggable", !0);
      }), Y.events.$on(s[Y.id], "dragstart", function (e) {
        var t = Y.$el.find("table.fr-table-selected");
        if (t && t.length) {
          i = !0;
          var a = t.clone(!0).removeClass("fr-table-selected fr-table-draggable"),
            l = a[0].outerHTML,
            r = a.text().trim();
          e.originalEvent.dataTransfer.setDragImage(t[0], 10, 10), e.originalEvent.dataTransfer.setData("text/html", l), e.originalEvent.dataTransfer.setData("text/plain", r);
          var n = new Blob([l], {
              type: "text/html"
            }),
            o = URL.createObjectURL(n);
          e.originalEvent.dataTransfer.setData("text/uri-list", o), e.originalEvent.dataTransfer.setData("DownloadURL", "text/html:table.html:".concat(o)), e.originalEvent.dataTransfer.effectAllowed = "Move", t.addClass("fr-table-draggable"), setTimeout(function () {
            return URL.revokeObjectURL(o);
          }, 5e3);
        }
      }), Y.events.$on(s[Y.id], "dragend", function (e) {
        i = !1, ne();
        var t = Y.$el.find("table.fr-table-draggable"),
          a = t.hasClass("not-drop");
        (e = e.originalEvent) && e.dataTransfer && "none" !== e.dataTransfer.dropEffect && !a ? t.remove() : t.removeClass("fr-table-draggable");
      }), Y.events.on("destroy", function () {
        oe(), s[Y.id] = null;
      });
    }
    function E(e) {
      var t = {
        startTag: "",
        closeTag: ""
      };
      return Y.opts.keepTextFormatOnTable && (t = R(function i(e) {
        var t = new Set(),
          a = e.textContent,
          l = 0,
          r = [e.firstChild];
        for (; 0 < r.length;) {
          var n = r.pop();
          if (n && (t.has(n) || (0 === l && a !== n.textContent && (a = n.textContent, l++), t.add(n)), n.hasChildNodes())) for (var o = 0; o < n.childNodes.length;) {
            if (3 === n.childNodes[o].nodeType) return Ge(t);
            if (n.childNodes[o].textContent) {
              if (0 === l && n.childNodes[o].textContent !== a) {
                a = n.childNodes[o].textContent, r.push(n.childNodes[o]), l++;
                break;
              }
              n.childNodes[o].textContent === a && r.push(n.childNodes[o]);
            }
            o++;
          }
        }
        return Ge(t);
      }(e).reverse())), {
        startTag: t.startTag,
        closeTag: t.closeTag
      };
    }
    function R(e) {
      var t = "",
        a = "",
        l = ["br", "#text", "#comment", "font"];
      if (0 < e.length) for (var r = e.length - 1; 0 <= r; r--) {
        var n = e[r],
          o = Y.node.isBlock(n),
          i = l.indexOf(n.nodeName.toLowerCase());
        if (!o && i < 0) {
          var s = n.style,
            c = "";
          if (s && s.length) {
            for (var f = 0; f < s.length; f++) c += s[f] + ": " + s[s[f]].replace(/"/gi, "") + "; ";
            c = c.trim();
          }
          t += c ? "<" + n.nodeName.toLowerCase() + ' style="' + c + '">' : "<" + n.nodeName.toLowerCase() + ">", a = "</" + n.nodeName.toLowerCase() + ">" + a;
        }
      }
      return {
        startTag: t,
        closeTag: a
      };
    }
    function x() {
      var e = ve(),
        t = ge(),
        a = 0 < t.length,
        l = 0 < e.length;
      (a || l) && (a && (Y.selection.setBefore(t[0]) || Y.selection.setAfter(t[0]), Y.selection.restore(), Y.popups.hide("table.edit")), y(e), Y.undo.saveStep(), oe(), V(), e.remove(), Y.$el.focus());
    }
    function A(e) {
      var t = ve();
      if (0 < t.length) {
        if (0 < Y.$el.find("thead .fr-selected-cell").length && "above" == e || 0 < Y.$el.find("tfoot td.fr-selected-cell").length && "below" == e) return;
        var a,
          l,
          r,
          n = j(),
          o = L(n);
        if (null == o) return;
        l = "above" == e ? o.min_i : o.max_i;
        var i = "<tr>";
        for (a = 0; a < n[l].length; a++) if ("below" == e && l < n.length - 1 && n[l][a] == n[l + 1][a] || "above" == e && 0 < l && n[l][a] == n[l - 1][a]) {
          if (0 === a || 0 < a && n[l][a] != n[l][a - 1]) {
            var s = Z(n[l][a]);
            s.attr("rowspan", parseInt(s.attr("rowspan"), 10) + 1);
          }
        } else {
          var c = Z(n[l][a]);
          if ("TH" == c.attr("tagName").toUpperCase()) i += '<th style="' + c.attr("style") + '" ><br></th>';else {
            var f = E(n[l][a]);
            i += '<td style="' + c.attr("style") + '" >' + f.startTag + "<br>" + f.closeTag + "</td>";
          }
        }
        i += "</tr>", r = 0 < Y.$el.find("thead .fr-selected-cell").length && "below" == e || 0 < Y.$el.find("tfoot td.fr-selected-cell").length && "above" == e ? Z(t.find("tbody").not(t.find("> table tbody"))) : Z(t.find("tr").not(t.find("> table tr")).get(l)), "below" == e ? "TBODY" == r.attr("tagName") ? r.prepend(i) : r[0].parentNode && r[0].insertAdjacentHTML("afterend", i) : "above" == e && ("TBODY" == r.attr("tagName") ? r.append(i) : r.before(i), Y.popups.isVisible("table.edit") && C());
      }
    }
    function O(e, t, a) {
      var l,
        r,
        n,
        o,
        i,
        s = 0,
        c = j(a);
      if (e < (t = Math.min(t, c[0].length - 1))) for (r = e; r <= t; r++) if (!(e < r && c[0][r] == c[0][r - 1]) && 1 < (o = Math.min(parseInt(c[0][r].getAttribute("colspan"), 10) || 1, t - e + 1)) && c[0][r] == c[0][r + 1]) for (s = o - 1, l = 1; l < c.length; l++) if (c[l][r] != c[l - 1][r]) {
        for (n = r; n < r + o; n++) if (c[l][n] !== undefined) if (1 < (i = parseInt(c[l][n].getAttribute("colspan"), 10) || 1) && c[l][n] == c[l][n + 1]) n += s = Math.min(s, i - 1);else if (!(s = Math.max(0, s - 1))) break;
        if (!s) break;
      }
      s && M(c, s, "colspan", 0, c.length - 1, e, t);
    }
    function H(e, t, a) {
      var l,
        r,
        n,
        o,
        i,
        s = 0,
        c = j(a);
      if (e < (t = Math.min(t, c.length - 1))) for (l = e; l <= t; l++) if (!(e < l && c[l][0] == c[l - 1][0]) && c[l][0] !== undefined && 1 < (o = Math.min(parseInt(c[l][0].getAttribute("rowspan"), 10) || 1, t - e + 1)) && c[l][0] == c[l + 1][0]) for (s = o - 1, r = 1; r < c[0].length; r++) if (c[l][r] != c[l][r - 1]) {
        for (n = l; n < l + o; n++) if (c[n][r] !== undefined) if (1 < (i = parseInt(c[n][r].getAttribute("rowspan"), 10) || 1) && c[n][r] == c[n + 1][r]) n += s = Math.min(s, i - 1);else if (!(s = Math.max(0, s - 1))) break;
        if (!s) break;
      }
      s && M(c, s, "rowspan", e, t, 0, c[0].length - 1);
    }
    function M(e, t, a, l, r, n, o) {
      var i, s, c;
      for (i = l; i <= r; i++) for (s = n; s <= o; s++) l < i && e[i][s] == e[i - 1][s] || n < s && e[i][s] == e[i][s - 1] || e[i][s] !== undefined && 1 < (c = parseInt(e[i][s].getAttribute(a), 10) || 1) && (1 < c - t ? e[i][s].setAttribute(a, c - t) : e[i][s].removeAttribute(a));
    }
    function $(e, t, a, l, r) {
      H(e, t, r), O(a, l, r);
    }
    function D(e) {
      e.style.removeProperty("border"), e.style.removeProperty("border-top"), e.style.removeProperty("border-bottom"), e.style.removeProperty("border-left"), e.style.removeProperty("border-right");
    }
    function j(e) {
      var c = [];
      if (null == (e = e || null) && 0 < ge().length && (e = ve()), e) {
        if (!e.find("tr").html().match(/xl[0-9]+/gi)) for (var t = e.find("tr:empty"), a = t.length - 1; 0 <= a; a--) Z(t[a]).remove();
        e.find("tr").not(e.find("> table tr")).each(function (i, e) {
          var t = Z(e),
            s = 0;
          t.find("> th, > td").each(function (e, t) {
            for (var a = Z(t), l = parseInt(a.attr("colspan"), 10) || 1, r = parseInt(a.attr("rowspan"), 10) || 1, n = i; n < i + r; n++) for (var o = s; o < s + l; o++) c[n] || (c[n] = []), c[n][o] ? s++ : c[n][o] = t;
            s += l;
          });
        });
      }
      return c;
    }
    function P(e, t) {
      for (var a = 0; a < t.length; a++) for (var l = 0; l < t[a].length; l++) if (t[a][l] == e) return {
        row: a,
        col: l
      };
    }
    function k(e, t, a) {
      for (var l = e + 1, r = t + 1; l < a.length;) {
        if (a[l][t] != a[e][t]) {
          l--;
          break;
        }
        l++;
      }
      for (l == a.length && l--; r < a[e].length;) {
        if (a[e][r] != a[e][t]) {
          r--;
          break;
        }
        r++;
      }
      return r == a[e].length && r--, {
        row: l,
        col: r
      };
    }
    function S() {
      Y.el.querySelector(".fr-cell-fixed") && Y.el.querySelector(".fr-cell-fixed").classList.remove("fr-cell-fixed"), Y.el.querySelector(".fr-cell-handler") && Y.el.querySelector(".fr-cell-handler").classList.remove("fr-cell-handler");
    }
    function V() {
      var e = Y.$el.find(".fr-selected-cell");
      0 < e.length && e.each(function () {
        var e = Z(this);
        e.removeClass("fr-selected-cell"), "" === e.attr("class") && e.removeAttr("class");
      }), S();
    }
    function N() {
      Y.events.disableBlur(), Y.selection.clear(), Y.$el.addClass("fr-no-selection"), Y.$el.blur(), Y.events.enableBlur();
    }
    function L(e) {
      var t = Y.$el.find(".fr-selected-cell");
      if (0 < t.length) {
        var a,
          l = e.length,
          r = 0,
          n = e[0].length,
          o = 0;
        for (a = 0; a < t.length; a++) {
          var i = P(t[a], e),
            s = k(i.row, i.col, e);
          l = Math.min(i.row, l), r = Math.max(s.row, r), n = Math.min(i.col, n), o = Math.max(s.col, o);
        }
        return {
          min_i: l,
          max_i: r,
          min_j: n,
          max_j: o
        };
      }
      return null;
    }
    function _(e) {
      var t = L(e);
      if (null != t) {
        var a = Z(e[t.min_i][t.min_j]),
          l = Z(e[t.min_i][t.max_j]),
          r = Z(e[t.max_i][t.min_j]);
        return {
          left: a.length && a.offset().left,
          right: l.length && l.offset().left + l.outerWidth(),
          top: a.length && a.offset().top,
          bottom: r.length && r.offset().top + r.outerHeight()
        };
      }
    }
    function I(e, t) {
      if (Z(e).is(t)) V(), Z(e).addClass("fr-selected-cell");else {
        N(), Y.edit.off();
        var a = j(),
          l = P(e, a),
          r = P(t, a);
        if (!l || !r) return;
        var n = function b(e, t, a, l, r) {
          var n,
            o,
            i,
            s,
            c = e,
            f = t,
            d = a,
            p = l;
          for (n = c; n <= f; n++) (1 < (parseInt(Z(r[n][d]).attr("rowspan"), 10) || 1) || 1 < (parseInt(Z(r[n][d]).attr("colspan"), 10) || 1)) && (s = k((i = P(r[n][d], r)).row, i.col, r), c = Math.min(i.row, c), f = Math.max(s.row, f), d = Math.min(i.col, d), p = Math.max(s.col, p)), (1 < (parseInt(Z(r[n][p]).attr("rowspan"), 10) || 1) || 1 < (parseInt(Z(r[n][p]).attr("colspan"), 10) || 1)) && (s = k((i = P(r[n][p], r)).row, i.col, r), c = Math.min(i.row, c), f = Math.max(s.row, f), d = Math.min(i.col, d), p = Math.max(s.col, p));
          for (o = d; o <= p; o++) (1 < (parseInt(Z(r[c][o]).attr("rowspan"), 10) || 1) || 1 < (parseInt(Z(r[c][o]).attr("colspan"), 10) || 1)) && (s = k((i = P(r[c][o], r)).row, i.col, r), c = Math.min(i.row, c), f = Math.max(s.row, f), d = Math.min(i.col, d), p = Math.max(s.col, p)), (1 < (parseInt(Z(r[f][o]).attr("rowspan"), 10) || 1) || 1 < (parseInt(Z(r[f][o]).attr("colspan"), 10) || 1)) && (s = k((i = P(r[f][o], r)).row, i.col, r), c = Math.min(i.row, c), f = Math.max(s.row, f), d = Math.min(i.col, d), p = Math.max(s.col, p));
          return c == e && f == t && d == a && p == l ? {
            min_i: e,
            max_i: t,
            min_j: a,
            max_j: l
          } : b(c, f, d, p, r);
        }(Math.min(l.row, r.row), Math.max(l.row, r.row), Math.min(l.col, r.col), Math.max(l.col, r.col), a);
        V(), e.classList.add("fr-cell-fixed"), t.classList.add("fr-cell-handler");
        for (var o = n.min_i; o <= n.max_i; o++) for (var i = n.min_j; i <= n.max_j; i++) Z(e).closest("table").is(Z(a[o][i]).closest("table")) && Z(a[o][i]).addClass("fr-selected-cell");
      }
    }
    function B(e) {
      var t = null,
        a = Z(e.target);
      return "TD" == e.target.tagName || "TH" == e.target.tagName ? t = e.target : 0 < a.closest("th", a.closest("thead")[0]).length ? t = a.closest("th", a.closest("thead")[0]).get(0) : 0 < a.closest("td", a.closest("tr")[0]).length && (t = a.closest("td", a.closest("tr")[0]).get(0)), -1 === Y.$el.html.toString().search(t) ? null : t;
    }
    function F() {
      V(), Y.popups.hide("table.edit");
    }
    function z(e) {
      var t = B(e);
      if ("false" == Z(t).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
      if (0 < ge().length && !t && F(), !Y.edit.isDisabled() || Y.popups.isVisible("table.edit")) if (1 != e.which || 1 == e.which && Y.helpers.isMac() && e.ctrlKey) (3 == e.which || 1 == e.which && Y.helpers.isMac() && e.ctrlKey) && t && F();else if (b = !0, t) {
        0 < ge().length && !e.shiftKey && F(), e.stopPropagation(), Y.events.trigger("image.hideResizer"), Y.events.trigger("video.hideResizer"), p = !0;
        var a = t.tagName.toLowerCase();
        e.shiftKey && 0 < Y.$el.find("".concat(a, ".fr-selected-cell")).length ? Z(Y.$el.find("".concat(a, ".fr-selected-cell")).closest("table")).is(Z(t).closest("table")) ? I(l, t) : N() : ((Y.keys.ctrlKey(e) || e.shiftKey) && "TD" === e.currentTarget.tagName && (1 < ge().length || 0 === Z(t).find(Y.selection.element()).length && !Z(t).is(Y.selection.element())) && N(), l = t, 0 < Y.opts.tableEditButtons.length && I(l, l));
      }
    }
    function K(e) {
      var t = Y.popups.areVisible();
      if (!Y.edit.isDisabled() && t && !t.hasClass("fr-do-not-hide")) return !0;
      var a = B(e);
      if (1 === ge().length && null === a && (Y.toolbar.enable(), V()), (1 === ge().length && a && "TD" !== a.tagName && "TH" !== a.tagName || !p && !Y.$tb.is(e.target) && !Y.$tb.is(Z(e.target).closest(".fr-toolbar"))) && (Y.toolbar.enable(), V()), ("BODY" === e.target.tagName || "HTML" === e.target.tagName) && !a && 0 < ge().length && Y.toolbar.enable(), !(1 != e.which || 1 == e.which && Y.helpers.isMac() && e.ctrlKey)) {
        if (b = !1, p) p = !1, B(e) || 1 != ge().length ? 0 < ge().length ? Y.selection.isCollapsed() ? (C(), Y.toolbar.enable()) : (V(), Y.edit.on()) : ge().length || (Y.$el.removeClass("fr-no-selection"), Y.edit.on()) : V();
        if (h) {
          if (h = !1, W.removeClass("fr-moving"), Y.$el.removeClass("fr-no-selection"), Y.edit.on(), W.hasClass("fr-table-col-resizer")) {
            var l = parseFloat(W.css("left")) + Y.opts.tableResizerOffset + Y.$wp.offset().left;
            Y.opts.iframe && (l -= Y.$iframe.offset().left), W.data("release-position", l), W.removeData("max-left"), W.removeData("max-right");
          } else {
            var r = parseFloat(W.css("top"));
            W.data("release-position", r), W.removeData("max-top"), W.removeData("max-bottom");
          }
          !function K() {
            var e = W.data("origin"),
              t = W.data("release-position");
            if (e !== t) {
              var a = W.data("first"),
                l = W.data("second"),
                r = W.data("table"),
                n = r.outerWidth();
              if (Y.undo.canDo() || Y.undo.saveStep(), W.hasClass("fr-table-col-resizer")) {
                var o = j(r),
                  i = o[0] ? o[0].length : 0,
                  s = we(r, i);
                if (-1 != a && -1 != l || !Y.opts.proportionalTableResize) {
                  var c = function z(e, t, a) {
                      for (var l = t[0] ? t[0].length : 0, r = e.outerWidth(), n = [], o = [], i = a.find("col"), s = 0; s < l; s++) {
                        var c = i.eq(s),
                          f = void 0,
                          d = parseFloat(c.attr("width") || c.css("width"));
                        if (d && !isNaN(d)) f = (c.attr("width") || "").includes("%") || (c.css("width") || "").includes("%") ? d / 100 * r : d;else {
                          var p = Z(t[0][s]);
                          f = p.outerWidth();
                        }
                        n[s] = f, o[s] = f / r * 100;
                      }
                      return {
                        currentWidths: n,
                        currentPercentages: o
                      };
                    }(r, o, s),
                    f = c.currentWidths,
                    d = c.currentPercentages,
                    p = Ge(d),
                    b = t - e,
                    h = b / n * 100;
                  if (Y.opts.proportionalTableResize) {
                    var u = (d[a] * (f[a] + t - e) / f[a]).toFixed(4),
                      g = (d[a] + d[l] - u).toFixed(4);
                    p[a] = +u, p[l] = +g;
                  } else {
                    p[a] += h, p[l] -= h;
                    if (p[a] < 1) {
                      var v = 1 - p[a];
                      p[a] = 1, p[l] -= v;
                    }
                    if (p[l] < 1) {
                      var m = 1 - p[l];
                      p[l] = 1, p[a] -= m;
                    }
                  }
                  Ee(s, p);
                }
                var C = s.find("col"),
                  w = -1 == a && 0 == l,
                  y = a == C.length - 1 && -1 == l;
                if (w || y) {
                  var E,
                    T = r.parent(),
                    R = parseFloat(T.css("padding-left")),
                    x = parseFloat(T.css("padding-right")),
                    A = R + x,
                    O = n / (T.width() - A) * 100;
                  "rtl" == Y.opts.direction && 0 === l || "rtl" != Y.opts.direction && 0 !== l ? E = (n + t - e) / n * O : ("rtl" == Y.opts.direction && 0 !== l || "rtl" != Y.opts.direction && 0 === l) && (E = (n - t + e) / n * O), r.css("width", "".concat(Math.round(E).toFixed(4), "%"));
                }
              } else {
                var H = r.find("tr"),
                  M = Math.round(t - e),
                  $ = r.height();
                if (-1 != a && -1 != l) {
                  var D = H.eq(a),
                    S = D.outerHeight(),
                    V = Math.max(S + M, Y.opts.tableResizingLimit);
                  r.css("height", ""), D.css("height", V + "px"), r.css("height", r.height() + "px");
                } else {
                  var N = -1 == a && 0 == l;
                  if (Y.opts.proportionalTableResize) {
                    var L = N ? -M : M;
                    Re(r, L + $);
                  } else {
                    if (r.css("height", ""), N) {
                      var _ = H.eq(0),
                        I = _.outerHeight(),
                        P = Math.max(I - M, Y.opts.tableResizingLimit);
                      _.css("height", P + "px");
                    } else {
                      var k = H.eq(H.length - 1),
                        B = k.outerHeight(),
                        F = Math.max(B + M, Y.opts.tableResizingLimit);
                      k.css("height", F + "px");
                    }
                    r.css("height", r.height() + "px");
                  }
                }
                Y.opts.iframe && Y.$iframe.height(Y.iframe_document.scrollingElement.offsetHeight);
              }
              Y.selection.restore(), Y.undo.saveStep(), Y.events.trigger("table.resized", [r.get(0)]);
            }
            W.removeData("origin"), W.removeData("release-position"), W.removeData("first"), W.removeData("second"), W.removeData("table");
          }(), ee();
        }
      }
    }
    function G(e) {
      if ((!(Z(e.currentTarget).is(Z(e.originalEvent.relatedTarget)) || e.currentTarget.contains(e.originalEvent.relatedTarget) || e.originalEvent.relatedTarget && e.originalEvent.relatedTarget.contains(e.currentTarget)) || e.currentTarget.querySelector("input, textarea")) && (Y.events.$on(Z("input, textarea"), "click", t), !0 === p && 0 < Y.opts.tableEditButtons.length)) {
        if (Z(e.currentTarget).closest("table").is(ve())) return void I(l, e.currentTarget);
        "TD" !== e.currentTarget.tagName && "TH" !== e.currentTarget.tagName && N();
      }
    }
    function U(e, t, a, l) {
      for (var r, n = t; n != Y.el && "TD" != n.tagName && "TH" != n.tagName && ("up" == l ? r = n.previousElementSibling : "down" == l && (r = n.nextElementSibling), !r);) n = n.parentNode;
      "TD" == n.tagName || "TH" == n.tagName ? function o(e, t) {
        for (var a = e; a && "TABLE" != a.tagName && a.parentNode != Y.el;) a = a.parentNode;
        if (a && "TABLE" == a.tagName) {
          var l = j(Z(a));
          "up" == t ? X(P(e, l), a, l) : "down" == t && q(P(e, l), a, l);
        }
      }(n, l) : r && ("up" == l && Y.selection.setAtEnd(r), "down" == l && Y.selection.setAtStart(r));
    }
    function X(e, t, a) {
      0 < Z(".tribute-container").length && "none" != Z(".tribute-container").css("display") || (0 < e.row ? Y.selection.setAtEnd(a[e.row - 1][e.col]) : U(0, t, 0, "up"));
    }
    function q(e, t, a) {
      if (!(0 < Z(".tribute-container").length && "none" != Z(".tribute-container").css("display"))) {
        var l = parseInt(a[e.row][e.col].getAttribute("rowspan"), 10) || 1;
        e.row < a.length - l ? Y.selection.setAtStart(a[e.row + l][e.col]) : U(0, t, 0, "down");
      }
    }
    function J(e) {
      var t = e.which,
        a = Y.selection.blocks();
      if (a.length && ("P" !== (a = a[0]).tagName && "DIV" !== a.tagName || (a = a.parentNode), "TD" == a.tagName || "TH" == a.tagName)) {
        for (var l = a; l && "TABLE" != l.tagName && l.parentNode != Y.el;) l = l.parentNode;
        if (l && "TABLE" == l.tagName && (je.KEYCODE.ARROW_LEFT == t || je.KEYCODE.ARROW_UP == t || je.KEYCODE.ARROW_RIGHT == t || je.KEYCODE.ARROW_DOWN == t) && (0 < ge().length && F(), Y.browser.webkit && (je.KEYCODE.ARROW_UP == t || je.KEYCODE.ARROW_DOWN == t))) {
          if (!function p(e, t, a) {
            if (!e) return !1;
            var l = "TD" === e.tagName || "TH" === e.tagName ? e : Z(e).parentsUntil(Y.el, "td, th").get(0);
            if (!l) return !1;
            if (l.textContent.trim().length <= 0 && 1 === l.children.length && "BR" === l.children[0].tagName) return !0;
            if (("TD" === l.tagName || "TH" === l.tagName) && e && e.nodeType !== Node.TEXT_NODE) if (e.children && 0 < e.children.length) {
              var r = t > e.children.length ? e.children.length - 1 : t - 1,
                n = e.children[r] || e.firstChild;
              n && "string" == typeof n.textContent && (t = (e = n).textContent.trim().length - 1);
            } else e.firstChild && "string" == typeof e.firstChild.textContent && (e = e.firstChild, t = e.textContent.trim().length - 1);
            var o = document.createRange();
            o.selectNodeContents(l);
            var i,
              s = o.getBoundingClientRect();
            if (e.textContent.trim().length <= 0 && e.getBoundingClientRect) i = e.getBoundingClientRect();else {
              var c = e;
              e.nodeType !== Node.TEXT_NODE && (c = function d(e) {
                var t = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null, !1),
                  a = null;
                for (; t.nextNode();) a = t.currentNode;
                return a;
              }(e), t = c && "up" === a ? c.textContent.length : 0);
              var f = document.createRange();
              f.setStart(c || e, t), f.collapse(!0), i = f.getBoundingClientRect();
            }
            {
              if ("up" === a) {
                if ("BR" === e.tagName) {
                  if (l.firstChild.isSameNode(e)) return !0;
                  if (e.previousSibling && (Y.node.isBlock(e.previousSibling) || Y.node.isVoid(e.previousSibling))) return !1;
                }
                return Math.abs(i.top - s.top) <= 6;
              }
              if ("down" === a) {
                if ("BR" === e.tagName) {
                  if (l.lastChild.isSameNode(e)) return !0;
                  if (e.nextSibling && (Y.node.isBlock(e.nextSibling) || Y.node.isVoid(e.nextSibling))) return l.lastChild.isSameNode(e.nextSibling) || !1;
                }
                return Math.abs(s.bottom - i.bottom) <= 6;
              }
            }
            return !1;
          }(Y.selection.ranges(0).startContainer, Y.selection.ranges(0).startOffset, je.KEYCODE.ARROW_UP == t ? "up" : "down")) return;
          e.preventDefault(), e.stopPropagation();
          var r = j(Z(l)),
            n = P(a, r);
          return je.KEYCODE.ARROW_UP == t ? X(n, l, r) : je.KEYCODE.ARROW_DOWN == t && q(n, l, r), Y.selection.restore(), !1;
        }
      }
    }
    function Q() {
      Y.shared.$table_resizer || (Y.shared.$table_resizer = Z(document.createElement("div")).attr("class", "fr-table-resizer").html("<div></div>")), W = Y.shared.$table_resizer, Y.events.$on(W, "mousedown", function (e) {
        return !Y.core.sameInstance(W) || (0 < ge().length && F(), 1 == e.which ? (Y.selection.save(), h = !0, W.addClass("fr-moving"), N(), Y.edit.off(), W.find("div").css("opacity", 1), !1) : void 0);
      }), Y.events.$on(W, "mousemove", function (e) {
        if (!Y.core.sameInstance(W)) return !0;
        h && (Y.opts.iframe && (e.pageX -= Y.$iframe.offset().left, e.pageY -= Y.$iframe.offset().top), pe(e));
      });
      var t = function t(e) {
        h && K(e);
      };
      window.addEventListener("mouseup", t, !0), Y.events.on("destroy", function () {
        window.removeEventListener("mouseup", t, !0);
      }, !0), Y.events.on("shared.destroy", function () {
        W.html("").removeData().remove(), W = null;
      }, !0), Y.events.on("destroy", function () {
        Y.$el.find(".fr-selected-cell").removeClass("fr-selected-cell"), Z("body").first().append(W.hide());
      }, !0);
    }
    function ee() {
      W && (W.find("div").css("opacity", 0), W.css("top", 0), W.css("left", 0), W.css("height", 0), W.css("width", 0), W.find("div").css("height", 0), W.find("div").css("width", 0), W.css("padding-top", 0), W.css("padding-bottom", 0), W.css("padding-left", 0), W.css("padding-right", 0), W.hide());
    }
    function te() {
      c && c.removeClass("fr-visible").css("left", "-9999px");
    }
    function ae(e, t) {
      if (Y.$box.find(".fr-line-breaker").isVisible()) return !1;
      c || he(), Y.$box.append(c), c.data("instance", Y);
      var a,
        l = Z(t).find("tr").first(),
        r = e.pageX,
        n = 0,
        o = 0;
      if (Y.opts.iframe) {
        var i = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-top")),
          s = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-left"));
        n += Y.$iframe.offset().left - Y.helpers.scrollLeft() + s, o += Y.$iframe.offset().top - Y.helpers.scrollTop() + i;
      }
      l.find("th, td").each(function () {
        var e = Z(this);
        return e.offset().left <= r && r < e.offset().left + e.outerWidth() / 2 ? (a = parseInt(c.find("a").css("width"), 10), c.css("top", o + e.offset().top - Y.$box.offset().top - a - 5), c.css("left", n + e.offset().left - Y.$box.offset().left - a / 2), c.data("selected-cell", e), c.data("position", "before"), c.addClass("fr-visible"), !1) : e.offset().left + e.outerWidth() / 2 <= r && r < e.offset().left + e.outerWidth() ? (a = parseInt(c.find("a").css("width"), 10), c.css("top", o + e.offset().top - Y.$box.offset().top - a - 5), c.css("left", n + e.offset().left - Y.$box.offset().left + e.outerWidth() - a / 2), c.data("selected-cell", e), c.data("position", "after"), c.addClass("fr-visible"), !1) : void 0;
      });
    }
    function le(e, t) {
      if (Y.$box.find(".fr-line-breaker").isVisible()) return !1;
      c || he(), Y.$box.append(c), c.data("instance", Y);
      var a,
        l = Z(t),
        r = e.pageY,
        n = 0,
        o = 0;
      if (Y.opts.iframe) {
        var i = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-top")),
          s = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-left"));
        n += Y.$iframe.offset().left - Y.helpers.scrollLeft() + s, o += Y.$iframe.offset().top - Y.helpers.scrollTop() + i;
      }
      l.find("tr").each(function () {
        var e = Z(this);
        a = parseInt(c.find("a").css("width"), 10);
        var t = n + e.offset().left - Y.$box.offset().left;
        return t = 0 !== Y.$box.offset().left ? t - a - 5 : t + a - 5, e.offset().top <= r && r < e.offset().top + e.outerHeight() / 2 ? (c.css("top", o + e.offset().top - Y.$box.offset().top - a / 2), c.css("left", t), c.data("selected-cell", e.find("td").first()), c.data("position", "above"), c.addClass("fr-visible"), !1) : e.offset().top + e.outerHeight() / 2 <= r && r < e.offset().top + e.outerHeight() ? (c.css("top", o + e.offset().top - Y.$box.offset().top + e.outerHeight() - a / 2), c.css("left", t), c.data("selected-cell", e.find("td").first()), c.data("position", "below"), c.addClass("fr-visible"), !1) : void 0;
      });
    }
    function re(e, t) {
      var a = Z(e);
      a.removeClass(t), a.length && a.get(0).hasAttribute("class") && !a.attr("class").trim() && a.removeAttr("class");
    }
    function ne() {
      s[Y.id] && !i && (re(s[Y.id], "fr-table-selector-active fr-table-selector-active-selected"), s[Y.id].addClass("fr-table-selector-inactive"), re(Y.$el.find("table.fr-table-selection-hover"), "fr-table-selection-hover"), function e() {
        s[Y.id].removeAttr("draggable"), u && (i = !1, u.hide(), u.removeAttr("data-position"), u.removeData("target-element"));
      }());
    }
    function oe() {
      re(Y.$el.find("table.fr-table-selected"), "fr-table-selected fr-table-selection-hover"), ne();
    }
    function ie(e) {
      Y.$box.append(s[Y.id]), s[Y.id].data("instance", Y);
      var t = e.offset().left - Y.$box.offset().left + 16,
        a = e.offset().top - Y.$box.offset().top - s[Y.id].outerHeight();
      if (Y.opts.iframe) {
        var l = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-top")),
          r = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-left"));
        t += Y.$iframe.offset().left - Y.helpers.scrollLeft() + r, a += Y.$iframe.offset().top - Y.helpers.scrollTop() + l;
      }
      s[Y.id].css("top", a), s[Y.id].css("left", t);
    }
    function se(e) {
      f = null;
      var t = Y.doc.elementFromPoint(e.pageX - Y.win.pageXOffset, e.pageY - Y.win.pageYOffset);
      Y.opts.tableResizer && (!Y.popups.areVisible() || Y.popups.areVisible() && Y.popups.isVisible("table.edit")) && function I(e, t) {
        var a,
          l = Z(t);
        l && (a = l.closest("table"));
        var r = a.parent();
        if (t && "TD" != t.tagName && "TH" != t.tagName && (0 < l.closest("td").length ? t = l.closest("td") : 0 < l.closest("th").length && (t = l.closest("th"))), !t || "TD" != t.tagName && "TH" != t.tagName) W && l.get(0) != W.get(0) && l.parent().get(0) != W.get(0) && Y.core.sameInstance(W) && ee();else {
          if (l = Z(t), 0 === Y.$el.find(l).length) return !1;
          var n = l.offset().left - 1,
            o = n + l.outerWidth(),
            i = l.offset().top - 1,
            s = i + l.outerHeight();
          if (Math.abs(e.pageX - n) <= Y.opts.tableResizerOffset || Math.abs(o - e.pageX) <= Y.opts.tableResizerOffset) {
            var c,
              f,
              d,
              p,
              b,
              h = j(a),
              u = P(t, h),
              g = k(u.row, u.col, h),
              v = a.offset().top,
              m = a.outerHeight() - 1;
            "rtl" != Y.opts.direction ? e.pageX - n <= Y.opts.tableResizerOffset ? (d = n, 0 < u.col ? (p = n - fe(u.col - 1, h) + Y.opts.tableResizingLimit, b = n + fe(u.col, h) - Y.opts.tableResizingLimit, c = u.col - 1, f = u.col) : (c = -1, f = 0, p = Y.$wp.offset().left - 1 + parseFloat(r.css("padding-left")), b = Y.opts.proportionalTableResize ? a.offset().left - 1 + a.width() - h[0].length * Y.opts.tableResizingLimit : n + fe(u.col, h) - Y.opts.tableResizingLimit)) : o - e.pageX <= Y.opts.tableResizerOffset && (d = o, g.col < h[g.row].length && h[g.row][g.col + 1] ? (p = o - fe(g.col, h) + Y.opts.tableResizingLimit, b = o + fe(g.col + 1, h) - Y.opts.tableResizingLimit, c = g.col, f = g.col + 1) : (c = g.col, f = -1, p = Y.opts.proportionalTableResize ? a.offset().left - 1 + h[0].length * Y.opts.tableResizingLimit : o - fe(g.col, h) + Y.opts.tableResizingLimit, b = r.offset().left - 1 + r.width() - parseFloat(r.css("padding-left")))) : o - e.pageX <= Y.opts.tableResizerOffset ? (d = o, 0 < u.col ? (p = o - fe(u.col, h) + Y.opts.tableResizingLimit, b = o + fe(u.col - 1, h) - Y.opts.tableResizingLimit, c = u.col, f = u.col - 1) : (c = null, f = 0, p = a.offset().left + h[0].length * Y.opts.tableResizingLimit, b = r.offset().left - 1 + r.width() + parseFloat(r.css("padding-left")))) : e.pageX - n <= Y.opts.tableResizerOffset && (d = n, g.col < h[g.row].length && h[g.row][g.col + 1] ? (p = n - fe(g.col + 1, h) + Y.opts.tableResizingLimit, b = n + fe(g.col, h) - Y.opts.tableResizingLimit, c = g.col + 1, f = g.col) : (c = g.col, f = null, p = r.offset().left + parseFloat(r.css("padding-left")), b = a.offset().left - 1 + a.width() - h[0].length * Y.opts.tableResizingLimit)), W || Q(), ee(), W.removeClass("fr-table-row-resizer"), W.addClass("fr-table-col-resizer"), W.data("table", a), W.data("first", c), W.data("second", f), W.data("instance", Y), Y.$wp.append(W);
            var C = d - Y.win.pageXOffset - Y.opts.tableResizerOffset - Y.$wp.offset().left,
              w = v - Y.$wp.offset().top + Y.$wp.scrollTop();
            if (Y.opts.iframe) {
              var y = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-top")),
                E = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-left"));
              C += Y.$iframe.offset().left + E, w += Y.$iframe.offset().top + y, p += Y.$iframe.offset().left, b += Y.$iframe.offset().left;
            }
            W.data("max-left", p), W.data("max-right", b), W.data("origin", d - Y.win.pageXOffset), W.css("top", w), W.css("left", C), W.css("height", m), W.find("div").css("height", m), W.css("padding-left", Y.opts.tableResizerOffset), W.css("padding-right", Y.opts.tableResizerOffset), W.show();
          } else if (Math.abs(e.pageY - i) <= Y.opts.tableResizerOffset || Math.abs(s - e.pageY) <= Y.opts.tableResizerOffset) {
            var T,
              R,
              x,
              A,
              O,
              H = j(a),
              M = P(t, H),
              $ = k(M.row, M.col, H),
              D = a.offset().left,
              S = a.outerWidth() - 1;
            e.pageY - i <= Y.opts.tableResizerOffset ? (x = i, 0 < M.row ? (A = i - de(M.row - 1, H), O = Y.win.outerHeight, T = M.row - 1, R = M.row) : (T = -1, R = 0, A = Y.$el.offset().top - 1 + parseInt(a.css("margin-top"), 10), O = Y.opts.proportionalTableResize ? a.offset().top - 1 + a.height() - H.length * Y.opts.tableResizingLimit : a.offset().top + l.height())) : s - e.pageY <= Y.opts.tableResizerOffset && (x = s, $.row < H.length - 1 ? (A = s - de($.row, H), O = Y.win.outerHeight, T = $.row, R = $.row + 1) : (T = $.row, R = -1, A = Y.opts.proportionalTableResize ? a.offset().top - 1 + H.length * Y.opts.tableResizingLimit : s - de($.row, H), O = Y.win.outerHeight)), W || Q(), ee(), W.removeClass("fr-table-col-resizer"), W.addClass("fr-table-row-resizer"), W.data("table", a), W.data("first", T), W.data("second", R), W.data("instance", Y), Y.$wp.append(W);
            var V = D - Y.$wp.offset().left,
              N = x - Y.$wp.offset().top + Y.$wp.scrollTop() - Y.opts.tableResizerOffset;
            if (Y.opts.iframe) {
              var L = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-top")),
                _ = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-left"));
              V += Y.$iframe.offset().left + _, N += Y.$iframe.offset().top + L, A += Y.$iframe.offset().top, O += Y.$iframe.offset().top;
            }
            W.data("max-top", A - Y.$wp.offset().top + Y.$wp.scrollTop() - Y.opts.tableResizerOffset), W.data("max-bottom", O - Y.$wp.offset().top + Y.$wp.scrollTop() - Y.opts.tableResizerOffset), W.data("origin", N), W.css("top", N), W.css("left", V), W.css("width", S), W.find("div").css("width", S), W.css("padding-top", Y.opts.tableResizerOffset), W.css("padding-bottom", Y.opts.tableResizerOffset), W.show();
          } else Y.core.sameInstance(W) && ee();
        }
      }(e, t), !Y.opts.tableInsertHelper || Y.popups.areVisible() || Y.$tb.hasClass("fr-inline") && Y.$tb.isVisible() || function n(e, t) {
        if (0 === ge().length) {
          var a, l, r;
          if (t && ("HTML" == t.tagName || "BODY" == t.tagName || Y.node.isElement(t))) for (a = 1; a <= Y.opts.tableInsertHelperOffset; a++) {
            if (l = Y.doc.elementFromPoint(e.pageX - Y.win.pageXOffset, e.pageY - Y.win.pageYOffset + a), Z(l).hasClass("fr-tooltip")) return !0;
            if (l && ("TH" == l.tagName || "TD" == l.tagName || "TABLE" == l.tagName) && (Z(l).parents(".fr-wrapper").length || Y.opts.iframe) && "false" != Z(l).closest("table").attr("contenteditable")) return ae(e, Z(l).closest("table")), !0;
            if (r = Y.doc.elementFromPoint(e.pageX - Y.win.pageXOffset + a, e.pageY - Y.win.pageYOffset), Z(r).hasClass("fr-tooltip")) return !0;
            if (r && ("TH" == r.tagName || "TD" == r.tagName || "TABLE" == r.tagName) && (Z(r).parents(".fr-wrapper").length || Y.opts.iframe) && "false" != Z(r).closest("table").attr("contenteditable")) return le(e, Z(r).closest("table")), !0;
          }
          Y.core.sameInstance(c) && te();
        }
      }(e, t), Y.opts.enableTableSelection && function i(e, t) {
        var a = Z(t),
          l = Y.$el.find("table.fr-table-selection-hover"),
          r = Y.$el.find("table.fr-table-selected");
        if (Y.node.isElement(t) || Y.node.isElement(a.parents(".fr-view").first().get(0)) || Y.core.sameInstance(a) || Y.core.sameInstance(a.parents("div.fr-table-selector"))) {
          if (!a.parents(".fr-table-selector").length) {
            var n = a.closest("table").filter(function () {
              return !(!Y.$el || !Y.$el.length) && Y.$el.get(0).contains(this);
            });
            if (n.length) {
              if (ie(n), s[Y.id].addClass("fr-table-selector-active"), re(s[Y.id], "fr-table-selector-inactive"), re(l, "fr-table-selection-hover"), r.length) {
                var o = r.get(0) === n.get(0);
                s[Y.id].toggleClass("fr-table-selector-active-selected", o), s[Y.id].attr("draggable", o);
              }
              n.addClass("fr-table-selection-hover");
            } else l.length && Math.abs(l.offset().top - e.pageY) < 5 || s[Y.id].hasClass("fr-table-selector-inactive") || ne();
          }
        } else r.length || ne();
      }(e, t);
    }
    function ce() {
      if (h) {
        var e = W.data("table").offset().top - Y.win.pageYOffset;
        if (Y.opts.iframe) {
          var t = Y.helpers.getPX(Y.$wp.find(".fr-iframe").css("padding-top"));
          e += Y.$iframe.offset().top - Y.helpers.scrollTop() + t;
        }
        W.css("top", e);
      }
    }
    function fe(e, t) {
      var a,
        l = Z(t[0][e]).outerWidth();
      for (a = 1; a < t.length; a++) l = Math.min(l, Z(t[a][e]).outerWidth());
      return l;
    }
    function de(e, t) {
      var a,
        l = Z(t[e][0]).outerHeight();
      for (a = 1; a < t[e].length; a++) l = Math.min(l, Z(t[e][a]).outerHeight());
      return l;
    }
    function pe(e) {
      if (1 < ge().length && b && N(), !1 === b && !1 === p && !1 === h) f && clearTimeout(f), Y.edit.isDisabled() && !Y.popups.isVisible("table.edit") || (f = setTimeout(se, 30, e));else if (h) {
        if (W.hasClass("fr-table-col-resizer")) {
          var t = e.pageX - Y.win.pageXOffset;
          Y.opts.iframe && (t += Y.$iframe.offset().left);
          var a = W.data("max-left"),
            l = W.data("max-right");
          a <= t && t <= l ? W.css("left", t - Y.opts.tableResizerOffset - Y.$wp.offset().left) : t < a && parseFloat(W.css("left"), 10) > a - Y.opts.tableResizerOffset ? W.css("left", a - Y.opts.tableResizerOffset - Y.$wp.offset().left) : l < t && parseFloat(W.css("left"), 10) < l - Y.opts.tableResizerOffset && W.css("left", l - Y.opts.tableResizerOffset - Y.$wp.offset().left);
        } else {
          var r = e.pageY - Y.win.pageYOffset;
          Y.opts.iframe && (r += Y.$iframe.offset().top);
          var n,
            o,
            i = W.data("max-top"),
            s = W.data("max-bottom");
          n = Y.opts.height ? (o = r - Y.opts.tableResizerOffset - Y.$wp.offset().top + Y.$wp.scrollTop(), Y.opts.iframe && (s = Y.win.innerHeight), o) : (o = r - Y.opts.tableResizerOffset - Y.$wp.offset().top + Y.helpers.scrollTop(), Y.opts.iframe && (o = r - Y.opts.tableResizerOffset - Y.$wp.offset().top), s = Y.win.innerHeight, e.clientY), i <= o && n <= s && W.css("top", o);
        }
      } else b && te();
    }
    function be(e) {
      Y.node.isEmpty(e.get(0)) ? Y.opts.keepTextFormatOnTable && Y.browser.mozilla ? e.append(je.MARKERS) : e.prepend(je.MARKERS) : e.prepend(je.START_MARKER).append(je.END_MARKER);
    }
    function he() {
      Y.shared.$ti_helper || (Y.shared.$ti_helper = Z(document.createElement("div")).attr("class", "fr-insert-helper").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(Y.language.translate("Insert"), '"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/></svg></a>')), Y.events.bindClick(Y.shared.$ti_helper, "a", function () {
        var e = c.data("selected-cell"),
          t = c.data("position"),
          a = c.data("instance") || Y;
        "before" == t ? (Y.undo.saveStep(), e.addClass("fr-selected-cell"), a.table.insertColumn(t), e.removeClass("fr-selected-cell"), Y.undo.saveStep()) : "after" == t ? (Y.undo.saveStep(), e.addClass("fr-selected-cell"), a.table.insertColumn(t), e.removeClass("fr-selected-cell"), Y.undo.saveStep()) : "above" == t ? (Y.undo.saveStep(), e.addClass("fr-selected-cell"), a.table.insertRow(t), e.removeClass("fr-selected-cell"), Y.undo.saveStep()) : "below" == t && (Y.undo.saveStep(), e.addClass("fr-selected-cell"), a.table.insertRow(t), e.removeClass("fr-selected-cell"), Y.undo.saveStep()), te();
      }), Y.events.on("shared.destroy", function () {
        Y.shared.$ti_helper.html("").removeData().remove(), Y.shared.$ti_helper = null;
      }, !0), Y.events.$on(Y.shared.$ti_helper, "mousemove", function (e) {
        e.stopPropagation();
      }, !0), Y.events.$on(Z(Y.o_win), "scroll", function () {
        te();
      }, !0), Y.events.$on(Y.$wp, "scroll", function () {
        te();
      }, !0)), c = Y.shared.$ti_helper, Y.events.on("destroy", function () {
        c = null;
      }), Y.tooltip.bind(Y.$box, ".fr-insert-helper > a.fr-floating-btn");
    }
    function ue() {
      l = null, clearTimeout(f);
    }
    function ge() {
      return Y.el.querySelectorAll(".fr-selected-cell");
    }
    function ve() {
      var e = ge(),
        t = Y.$el.find("table.fr-table-selected");
      if (e.length) {
        for (var a = e[0]; a && "TABLE" != a.tagName && a.parentNode != Y.el;) a = a.parentNode;
        return a && "TABLE" == a.tagName ? Z(a) : Z([]);
      }
      return t.length ? Z(t.get(0)) : Z([]);
    }
    function me(e) {
      var t = Y.popups.get("table.tableProperties"),
        a = t.find(".fr-table-alignment-container"),
        l = a.find(".fr-table-".concat(e, "-align")).get(0);
      a.find(".fr-table-left-align").get(0).innerHTML = Y.icon.create("leftTableAlign"), a.find(".fr-table-center-align").get(0).innerHTML = Y.icon.create("centerTableAlign"), a.find(".fr-table-right-align").get(0).innerHTML = Y.icon.create("rightTableAlign"), l.innerHTML = Y.icon.create("".concat(e, "TableAlignActive")), l.focus(), t.data("tableAlign", e);
    }
    function Ce() {
      var e = {
          buttons: "",
          table_properties_form: '\n         <div class="fr-table-properties-form">\n            <div class="fr-table-properties-section">\n              <label>Background</label>\n              <div class="fr-table-bg-container">\n                <div class="fr-input-line">\n                  <input type="text" title="'.concat(Y.language.translate("Custom background color input"), '" id="fr-table-bg" class="fr-input" placeholder="Color" tabIndex="1" aria-required="true">\n                </div>\n                <button title="').concat(Y.language.translate("Background color picker"), '" role="button" type="button" class="fr-command fr-enable-accessibility fr-btn-table-bg-color" data-param1="table" tabIndex="2" data-cmd="openColorPicker">\n                  <div class="fr-color-preview">\n                    <div class="fr-color-preview-indicator"></div>\n                  </div>\n                </button>\n              </div>\n              <label>Border</label>\n              <div class="fr-table-border-container">\n                <div class="fr-input-line">\n                  <label class="fr-field-lable">Style</label>\n                  <div class= "fr-buttons fr-border-style"> ').concat(Y.button.build("tableBorderStyle", je.COMMANDS.tableBorderStyle, !0), '</div>\n                </div>\n                <div class="fr-input-line">\n                  <input  title="').concat(Y.language.translate("Custom border color input"), '" id="fr-table-border-color" class="fr-input" type="text" placeholder="Color" tabIndex="3" aria-required="true">\n                </div>\n                <button  title="').concat(Y.language.translate("Border color picker"), '" role="button" type="button" class="fr-command fr-btn-table-border-bg-color fr-enable-accessibility" tabIndex="4" data-param1="border" data-cmd="openColorPicker">\n                  <div class="fr-border-color-preview">\n                    <div class="fr-border-color-preview-indicator"></div>\n                  </div>\n                </button>\n                <div class="fr-input-line">\n                  <input  title="').concat(Y.language.translate("Border width"), '" id="fr-table-border-width" type="text" class="fr-input" placeholder="Width" tabIndex="5" aria-required="true">\n                </div>\n              </div>\n              <div class="fr-table-dimentions-section">\n                <div>\n                  <label>Dimentions</label>\n                  <div class="fr-table-dimentions-container">\n                    <div class="fr-input-line">\n                      <input title="').concat(Y.language.translate("Table width"), '" type="text" id="fr-table-width" placeholder="Width" tabIndex="6">\n                    </div>\n                    <span class="fr-dimension-separator">\xd7</span>\n                    <div class="fr-input-line">\n                      <input title="').concat(Y.language.translate("Table height"), '" type="text" id="fr-table-height" placeholder="Height" tabIndex="7">\n                    </div>\n                  </div>\n                </div>\n                <div class="fr-table-alignment-section">\n                  <label>Alignment</label>\n                  <div class="fr-table-alignment-container">\n                    <button title="').concat(Y.language.translate("Left align"), '" class="fr-enable-accessibility fr-command fr-table-left-align" data-param1="left" data-cmd="tableAlign" tabIndex="8">').concat(Y.icon.create("leftTableAlign"), '</button>\n                    <button title="').concat(Y.language.translate("Center align"), '" class="fr-enable-accessibility fr-command fr-table-center-align" data-param1="center" data-cmd="tableAlign" tabIndex="9">').concat(Y.icon.create("centerTableAlign"), '</button>\n                    <button title="').concat(Y.language.translate("Right align"), '" class="fr-enable-accessibility fr-command fr-table-right-align" data-param1="right" data-cmd="tableAlign" tabIndex="10">').concat(Y.icon.create("rightTableAlign"), '</button>\n                  </div>\n                </div>\n              </div>\n              <label>Table style</label>\n              <div class="fr-table-style-container">\n                <div class="fr-input-line">\n                  <label class="fr-field-lable">Style</label>\n                  <div class= "fr-buttons fr-table-style"> ').concat(Y.button.build("tableStyle", je.COMMANDS.tableStyle, !0), '</div>\n                </div>\n              </div>\n            </div>\n            <div class="fr-table-properties-buttons">\n              <button title="').concat(Y.language.translate("Cancel"), '" role="button" type="button" class="fr-enable-accessibility fr-command fr-cancel-button" tabIndex="11" data-cmd="onCancel">Cancel</button>\n              <button title="').concat(Y.language.translate("Save"), '" role="button" type="button" class="fr-enable-accessibility fr-command fr-save-button" tabIndex="12" data-cmd="applyTableProperties">Save</button>\n            </div>\n          </div>\n        ')
        },
        n = Y.popups.create("table.tableProperties", e),
        t = function t(e, l, r) {
          n.find(e).on("keydown", function (t) {
            var e = Z(t.target),
              a = t.which;
            a !== je.KEYCODE.ENTER && a !== je.KEYCODE.ARROW_DOWN && a !== je.KEYCODE.SPACE || e.hasClass("fr-active") || !e.is("button") || (l && r && Y.button.click(e), t.preventDefault(), t.stopPropagation()), setTimeout(function () {
              if (a === je.KEYCODE.TAB && l && r) {
                var e = t.shiftKey ? n.find(l) : n.find(r);
                e && e.length && e.focus(), t.preventDefault(), t.stopPropagation();
              }
            }, 10);
          });
        };
      return t(".fr-border-style > button", ".fr-btn-table-bg-color", "#fr-table-border-color"), t(".fr-border-style > .fr-dropdown-menu li", ".fr-btn-table-bg-color", "#fr-table-border-color"), t(".fr-table-style > button", ".fr-table-right-align", ".fr-cancel-button"), t(".fr-table-style > .fr-dropdown-menu li", ".fr-table-right-align", ".fr-cancel-button"), t(".fr-save-button", ".fr-cancel-button", "#fr-table-bg"), n;
    }
    function t() {
      p = !1;
    }
    function we(e, t) {
      var a = e.find("colgroup");
      0 === a.length && (a = Z(Y.doc.createElement("colgroup")), e.prepend(a));
      var l = a.find("col").length;
      if (l < t) for (var r = l; r < t; r++) a.append(Z(Y.doc.createElement("col")));else t < l && a.find("col").slice(t).remove();
      return Ee(a, ye(e)), e.find("th, td").each(function () {
        Z(this).css("width", "");
      }), a;
    }
    function ye(e) {
      var t = [];
      return e.find("colgroup").find("col").each(function () {
        var e = Math.round(Z(this).width()) || 0;
        t.push(e);
      }), t;
    }
    function Ee(e, t) {
      var a = e.find("col"),
        l = t.reduce(function (e, t) {
          return e + t;
        }, 0);
      if (.01 < Math.abs(l - 100)) {
        var r = 100 / l;
        t = t.map(function (e) {
          return e * r;
        });
      }
      a.each(function (e) {
        e < t.length && Z(this).css("width", t[e].toFixed(4) + "%");
      });
    }
    function Te(e) {
      var t = function f(e) {
        var t = e.target,
          l = e.clientY;
        if ("OL" === t.tagName || "UL" === t.tagName) {
          var a = Z(t).find("li"),
            r = null,
            n = Infinity;
          return a.each(function () {
            var e = this.getBoundingClientRect(),
              t = e.top + e.height / 2,
              a = Math.abs(l - t);
            a < n && (n = a, r = this);
          }), r || t;
        }
        var o = Z(t).closest("li")[0];
        if (o) return o;
        return function i(e) {
          var t = e;
          for (; t && t !== Y.$el[0];) {
            if (Y.node.isBlock(t)) return t;
            t = t.parentElement;
          }
          return null;
        }(t);
      }(e);
      if (t) {
        var a = t.getBoundingClientRect(),
          l = e.clientY,
          r = parseFloat(Z(t).css("margin-top")) || 0,
          n = parseFloat(Z(t).css("margin-bottom")) || 0,
          o = l < a.top + a.height / 2,
          i = o ? -r : n,
          s = (o ? a.top : a.bottom) - Y.$box.offset().top + Y.helpers.scrollTop() + i / 2,
          c = a.x - Y.$wp.offset().left;
        u || (u = Z(Y.doc.createElement("div")).addClass("fr-table-drop-indicator").html('<div class="fr-table-drop-indicator-line"></div>'), Y.$box.append(u)), Y.opts.iframe && (s += Y.$iframe.offset().top, c += Y.$iframe.offset().left), u.css({
          top: s + "px",
          left: c,
          width: a.width + "px"
        }).attr("data-position", o ? "above" : "below").data("target-element", t), u.show();
      }
    }
    function Re(e, t) {
      e.css("height", "");
      var a = e.height(),
        l = e.find("tr"),
        r = (t - a) / l.length;
      l.each(function () {
        var e = Z(this),
          t = e.outerHeight(),
          a = Math.max(t + r, Y.opts.tableResizingLimit);
        e.css("height", a + "px");
      }), e.css("height", "".concat(t, "px"));
    }
    return {
      _init: function xe() {
        if (!Y.$wp) return !1;
        if (Y.helpers.isMobile() && (Y.events.$on(Y.$el, "mousedown", z), Y.events.$on(Y.$win, "mouseup", K)), !Y.helpers.isMobile()) {
          h = p = b = !1, Y.events.$on(Y.$el, "mousedown", z), Y.popups.onShow("image.edit", function () {
            V(), p = b = !1;
          }), Y.popups.onShow("link.edit", function () {
            V(), p = b = !1;
          }), Y.events.$on(Y.$el, "mouseover", "th, td", G), Y.events.$on(Y.$win, "mouseup", K), Y.opts.iframe && Y.events.$on(Z(Y.o_win), "mouseup", K), Y.events.$on(Y.$win, "mousemove", pe), Y.events.$on(Z(Y.o_win), "scroll", ce), Y.events.on("contentChanged", function () {
            ne(), 0 < ge().length && !Y.popups.isVisible("table.tableProperties") && (C(), Y.$el.find("img").on("load.selected-cells", function () {
              Z(this).off("load.selected-cells"), 0 < ge().length && C();
            }));
          }), Y.events.$on(Z(Y.o_win), "resize", function () {
            V();
          }), Y.events.on("toolbar.esc", function () {
            if (0 < ge().length) return Y.events.disableBlur(), Y.events.focus(), !1;
          }, !0), Y.events.$on(Z(Y.o_win), "keydown", function () {
            b && p && (p = b = !1, Y.$el.removeClass("fr-no-selection"), Y.edit.on(), Y.selection.setAtEnd(Y.$el.find(".fr-selected-cell").last().get(0)), Y.selection.restore(), V());
          }), Y.events.$on(Y.$el, "keydown", function (e) {
            e.shiftKey ? !1 === function o(e) {
              var t = ge();
              if (null != t && 0 < t.length) {
                var a,
                  l = j(),
                  r = e.which,
                  n = P(1 == t.length ? a = t[0] : (a = Y.el.querySelector(".fr-cell-fixed"), Y.el.querySelector(".fr-cell-handler")), l);
                if (je.KEYCODE.ARROW_RIGHT == r) {
                  if (n.col < l[0].length - 1) return I(a, l[n.row][n.col + 1]), !1;
                } else if (je.KEYCODE.ARROW_DOWN == r) {
                  if (n.row < l.length - 1) return I(a, l[n.row + 1][n.col]), !1;
                } else if (je.KEYCODE.ARROW_LEFT == r) {
                  if (0 < n.col) return I(a, l[n.row][n.col - 1]), !1;
                } else if (je.KEYCODE.ARROW_UP == r && 0 < n.row) return I(a, l[n.row - 1][n.col]), !1;
              }
            }(e) && setTimeout(function () {
              C();
            }, 0) : J(e);
          }), Y.events.on("keydown", function (e) {
            if (!1 === function v(e) {
              if (e.which == je.KEYCODE.TAB) {
                var t;
                if (0 < ge().length) t = Y.$el.find(".fr-selected-cell").last();else {
                  var a = Y.selection.element();
                  "TD" == a.tagName || "TH" == a.tagName ? t = Z(a) : a != Y.el && (0 < Z(a).parentsUntil(Y.$el, "td").length ? t = Z(a).parents("td").first() : 0 < Z(a).parentsUntil(Y.$el, "th").length && (t = Z(a).parents("th").first()));
                }
                if (t) return e.preventDefault(), !!(0 === Y.selection.get().focusOffset && 0 < Z(Y.selection.element()).parentsUntil(Y.$el, "ol, ul").length && (0 < Z(Y.selection.element()).closest("li").prev().length || Z(Y.selection.element()).is("li") && 0 < Z(Y.selection.element()).prev().length)) || (F(), e.shiftKey ? 0 < t.prev().length ? be(t.prev()) : 0 < t.closest("tr").length && 0 < t.closest("tr").prev().length ? be(t.closest("tr").prev().find("td").last()) : 0 < t.closest("tbody").length && 0 < t.closest("table").find("thead tr").length && be(t.closest("table").find("thead tr th").last()) : 0 < t.next().length ? be(t.next()) : 0 < t.closest("tr").length && 0 < t.closest("tr").next().length ? be(t.closest("tr").next().find("td").first()) : 0 < t.closest("thead").length && 0 < t.closest("table").find("tbody tr").length ? be(t.closest("table").find("tbody tr td").first()) : (t.addClass("fr-selected-cell"), A("below"), V(), be(t.closest("tr").next().find("td").first())), Y.selection.restore(), !1);
              }
            }(e)) return !1;
            var t = function t() {
                V(), oe(), e.preventDefault(), e.stopPropagation();
              },
              a = Y.$el.find("table.fr-table-selected"),
              l = e.which;
            if (a.length && !Y.keys.isArrow(e.which) && l !== je.KEYCODE.TAB && l !== je.KEYCODE.ALT && l !== je.KEYCODE.ESC) {
              if (e.ctrlKey || e.metaKey || l === je.KEYCODE.SHIFT) return !0;
              x(), Y.undo.saveStep(), t();
              var r = Y.html.defaultTag();
              if (l === je.KEYCODE.ENTER || Y.keys.isCharacter(l) && !e.ctrlKey && !e.metaKey) {
                var n,
                  o = l === je.KEYCODE.ENTER;
                n = r ? o ? "<".concat(r, ' id="cursor-marker"></').concat(r, ">") : "<".concat(r, ' id="cursor-marker"> ').concat(l === je.KEYCODE.SPACE ? "&nbsp;" : e.key, "</").concat(r, ">") : o ? '<br id="cursor-marker">' : "".concat(l === je.KEYCODE.SPACE ? "&nbsp;" : e.key, ' <br id="cursor-marker">'), Y.html.insert(n, !0, !0);
                var i = Y.$el.find("#cursor-marker").get(0);
                i && i.parentNode && setTimeout(function () {
                  var e = Y.doc.createRange();
                  e.setStart(i, o ? 0 : 1), e.setEnd(i, o ? 0 : 1), e.collapse(!0);
                  var t = Y.selection.get();
                  t.removeAllRanges(), t.addRange(e), Y.$el.focus();
                }, 0), i && i.removeAttribute("id");
              }
              return !1;
            }
            if (a.length && Y.keys.isArrow(e.which)) {
              var s = e.which === je.KEYCODE.ARROW_DOWN || e.which === je.KEYCODE.ARROW_RIGHT,
                c = e.which === je.KEYCODE.ARROW_UP || e.which === je.KEYCODE.ARROW_LEFT;
              if (s || c) {
                var f = s ? a.next() : a.prev();
                if (f && f.length && f[0].nodeType === Node.ELEMENT_NODE) {
                  var d = f[0];
                  if ("UL" === d.tagName || "OL" === d.tagName) {
                    var p = d.querySelectorAll("li");
                    0 < p.length && (d = p[p.length - 1]);
                  }
                  (0 === d.childNodes.length || 1 === d.childNodes.length && "BR" === d.firstChild.nodeName) && (d.innerHTML = "", d.appendChild(document.createTextNode("\u200b")));
                  var b = Y.doc.createRange();
                  s ? b.setStartBefore(f[0]) : (b.selectNodeContents(d), b.collapse(!1));
                  var h = Y.selection.get();
                  h.removeAllRanges(), h.addRange(b), setTimeout(function () {
                    Y.events.disableBlur(), Y.$el[0].focus(), Y.events.enableBlur();
                  }, 0);
                }
              }
              return t(), !1;
            }
            !(e.ctrlKey || e.metaKey) && a.length && (V(), oe()), ne();
            var u = ge();
            if (0 < u.length) {
              if (0 < u.length && Y.keys.ctrlKey(e) && e.which == je.KEYCODE.A) return V(), Y.popups.isVisible("table.edit") && Y.popups.hide("table.edit"), u = [], !0;
              if (e.which == je.KEYCODE.ESC && Y.popups.isVisible("table.edit")) return V(), Y.popups.hide("table.edit"), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), !(u = []);
              if (1 < u.length && (e.which == je.KEYCODE.BACKSPACE || e.which == je.KEYCODE.DELETE)) {
                Y.undo.saveStep();
                for (var g = 0; g < u.length; g++) Z(u[g]).html("<br>"), g == u.length - 1 && Z(u[g]).prepend(je.MARKERS);
                return Y.selection.restore(), Y.undo.saveStep(), !(u = []);
              }
              if (1 < u.length && e.which != je.KEYCODE.F10 && !Y.keys.isBrowserAction(e)) return e.preventDefault(), !(u = []);
            } else if (!(u = []) === function m(e) {
              if (e.altKey && e.which == je.KEYCODE.SPACE) {
                var t,
                  a = Y.selection.element();
                if ("TD" == a.tagName || "TH" == a.tagName ? t = a : 0 < Z(a).closest("td").length ? t = Z(a).closest("td").get(0) : 0 < Z(a).closest("th").length && (t = Z(a).closest("th").get(0)), t) return e.preventDefault(), I(t, t), C(), !1;
              }
            }(e)) return !1;
          }, !0);
          var t = null,
            a = [];
          Y.events.on("html.beforeGet", function () {
            a = ge();
            for (var e = 0; e < a.length; e++) a[e].className = (a[e].className || "").replace(/fr-selected-cell/g, "");
            (t = Y.$el.find("table.fr-table-selected")) && t.length && re(t, "fr-table-selected");
          }), Y.events.on("html.afterGet", function () {
            for (var e = 0; e < a.length; e++) a[e].className = (a[e].className ? a[e].className.trim() + " " : "") + "fr-selected-cell";
            a = [], t && t.length && t.addClass("fr-table-selected");
          });
          var f = !1,
            d = ["applytextColor", "bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "applybackgroundColor", "inlineClass", "inlineStyle", "alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "paragraphFormat", "paragraphStyle", "lineHeight", "outdent", "indent", "quote", "clearFormatting"];
          Y.events.on("commands.before", function (e, t) {
            if (!f && 1 < ge().length && -1 !== d.indexOf(e)) {
              Y.undo.saveStep(), Y.selection.save(), Y.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-placeholder");
              var a = je.COMMANDS[e].undo;
              je.COMMANDS[e].undo = !1, f = !0;
              for (var l = {}, r = 0; r < ge().length; r++) {
                var n = ge()[r],
                  o = n.closest("tr").rowIndex;
                l[o] || (l[o] = []), l[o].push(n);
              }
              for (var i in l) {
                var s = l[i];
                Y.selection.get().removeAllRanges();
                var c = Y.doc.createRange();
                c.setStartBefore(s[0]), c.setEndAfter(s[s.length - 1]), Y.selection.get().addRange(c), Y.commands.exec(e, [t]);
              }
              return Y.$el.find(".fr-marker-placeholder").addClass("fr-marker").removeClass("fr-marker-placeholder"), Y.selection.restore(), Y.undo.saveStep(), je.COMMANDS[e].undo = a, f = !1;
            }
          }), Y.events.on("dragover", function (e) {
            if (F(), i) {
              e.preventDefault(), e.stopPropagation();
              var t = Y.$el.find("table.fr-table-selected"),
                a = e.target;
              if (t.is(a) || t.contains(a)) return u && u.hide(), void t.addClass("not-drop");
              Y.$el.is(a) ? t.addClass("not-drop") : t.removeClass("not-drop"), Te(e.originalEvent);
            }
          }), Y.events.on("element.dropped", function (e) {
            F(), p = b = !1;
            var t = B({
              target: e.get(0)
            });
            t && (I(t, t), C());
          }), Y.el.addEventListener("copy", function (e) {
            var t = function d() {
              var e = ge();
              if (!e || 0 === e.length) return null;
              var t = e[0],
                a = e[e.length - 1],
                l = t.parentElement,
                r = a.parentElement,
                n = l.closest("table"),
                o = Array.from(n.rows),
                i = o.indexOf(l),
                s = o.indexOf(r),
                c = Array.from(l.cells).indexOf(t),
                f = Array.from(r.cells).indexOf(a);
              return {
                rows: o.slice(i, s + 1).map(function (e) {
                  return Array.from(e.cells).slice(c, f + 1);
                })
              };
            }();
            if (t) {
              var a = t.rows.map(function (e) {
                  return "<tr>" + e.map(function (e) {
                    var t = e.tagName.toLowerCase(),
                      a = e.getAttribute("style");
                    return "<".concat(t).concat(a ? ' style="'.concat(a, '"') : "", ">").concat(e.innerHTML, "</").concat(t, ">");
                  }).join("") + "</tr>";
                }).join(""),
                l = t.rows.map(function (e) {
                  return e.map(function (e) {
                    return e.textContent.trim();
                  }).join("\t");
                }).join("\n"),
                r = "<table>".concat(a, "</table>");
              Y.paste.saveCopiedText(r, l), e.clipboardData.setData("text/html", r), e.preventDefault();
            }
          }), Y.events.on("commands.after", function (e) {
            if ("applyTableProperties" === e) {
              var t = Y.$el.find(".fr-selected-cell").closest("table"),
                a = !!t.length && parseFloat(t[0].style.height);
              a && Re(t, a);
            }
          }), n(!0), o(!0), e();
        }
        Y.events.on("destroy", ue);
      },
      insert: function Ae(e, t) {
        var a = function d() {
            var e = {
              startTag: "",
              closeTag: ""
            };
            if (Y.opts.keepTextFormatOnTable) {
              var t = Z(Y.selection.element().firstChild).parentsUntil(Y.$el);
              e = R(t);
            }
            return {
              startTag: e.startTag,
              closeTag: e.closeTag
            };
          }(),
          l = [];
        Y.opts.tableDefaultWidth && l.push("width: " + Y.opts.tableDefaultWidth + ";"), Y.opts.tableDefaultHeight && l.push("height: " + Y.opts.tableDefaultHeight + ";"), l.push("margin: auto;"), "left" === Y.opts.tableDefaultAlign ? l.push("float: left;") : "right" === Y.opts.tableDefaultAlign && l.push("float: right;"), Y.opts.tableDefaultBorderColor && l.push("border-color: " + Y.opts.tableDefaultBorderColor + ";"), Y.opts.tableDefaultBorderWidth && l.push("border-width: " + Y.opts.tableDefaultBorderWidth + ";"), Y.opts.tableDefaultBorderStyle && l.push("border-style: " + Y.opts.tableDefaultBorderStyle + ";"), Y.opts.tableDefaultBGColor && l.push("background-color: " + Y.opts.tableDefaultBorderStyle + ";");
        var r,
          n,
          o = l.join(" "),
          i = "<table " + (o ? 'style="' + o + '"' : "") + ' class="fr-inserted-table">',
          s = 100 / t;
        for (i += "<colgroup>", n = 0; n < t; n++) i += "<col" + (Y.opts.tableDefaultWidth ? ' style="width: ' + s.toFixed(4) + '%;"' : "") + ">";
        for (i += "</colgroup>", i += "<tbody>", r = 0; r < e; r++) {
          for (i += "<tr>", n = 0; n < t; n++) i += "<td>" + a.startTag, 0 === r && 0 === n && (i += je.MARKERS), i += "<br>" + a.closeTag + "</td>";
          i += "</tr>";
        }
        if (i += "</tbody></table>", Y.opts.trackChangesEnabled) {
          Y.edit.on(), Y.events.focus(!0), Y.selection.restore(), Y.undo.saveStep(), Y.markers.insert(), Y.html.wrap();
          var c = Y.$el.find(".fr-marker");
          Y.node.isLastSibling(c) && c.parent().hasClass("fr-deletable") && c.insertAfter(c.parent()), c.replaceWith(i), Y.selection.clear();
        } else g = !0, Y.html.insert(i);
        Y.selection.restore();
        var f = Y.$el.find(".fr-inserted-table");
        re(f, "fr-inserted-table"), Y.events.trigger("table.inserted", [f.get(0)]);
      },
      remove: x,
      insertRow: A,
      deleteRow: function Oe() {
        var e = ve();
        if (0 < e.length) {
          var t,
            a,
            l,
            r = j(),
            n = L(r);
          if (null == n) return;
          if (0 === n.min_i && n.max_i == r.length - 1) x();else {
            for (t = n.max_i; t >= n.min_i; t--) {
              for (l = Z(e.find("tr").not(e.find("> table tr")).get(t)), a = 0; a < r[t].length; a++) if (0 === a || r[t][a] != r[t][a - 1]) {
                var o = Z(r[t][a]);
                if (1 < parseInt(o.attr("rowspan"), 10)) {
                  var i = parseInt(o.attr("rowspan"), 10) - 1;
                  1 == i ? o.removeAttr("rowspan") : o.attr("rowspan", i);
                }
                if (t < r.length - 1 && r[t][a] == r[t + 1][a] && (0 === t || r[t][a] != r[t - 1][a])) {
                  for (var s = r[t][a], c = a; 0 < c && r[t][c] == r[t][c - 1];) c--;
                  0 === c ? Z(e.find("tr").not(e.find("> table tr")).get(t + 1)).prepend(s) : Z(r[t + 1][c - 1])[0].parentNode && Z(r[t + 1][c - 1])[0].insertAdjacentElement("afterend", s);
                }
              }
              var f = l.parent();
              l.remove(), 0 === f.find("tr").length && f.remove(), r = j(e);
            }
            $(0, r.length - 1, 0, r[0].length - 1, e), 0 < n.min_i ? Y.selection.setAtEnd(r[n.min_i - 1][0]) : Y.selection.setAtEnd(r[0][0]), Y.selection.restore(), Y.popups.hide("table.edit");
          }
        }
      },
      insertColumn: function He(d) {
        var e = ve();
        if (0 < e.length) {
          var p = j(),
            t = L(p),
            b = "before" == d ? t.min_j : t.max_j;
          we(e, p[0].length);
          var a = ye(e);
          a = function i(e) {
            var t = e.reduce(function (e, t) {
              return e + t;
            }, 0);
            if (0 < t) return e.map(function (e) {
              return e / t * 100;
            });
            var a = 100 / e.length;
            return new Array(e.length).fill(a);
          }(a);
          var l,
            r = 100 / (p[0].length + 1),
            n = (100 - r) / 100,
            o = a.map(function (e) {
              return e * n;
            });
          e.find("th, td").each(function () {
            (l = Z(this)).data("old-width", l.outerWidth() / e.outerWidth() * 100);
          }), function c(e, t, a, l, r) {
            var n = e.find("colgroup"),
              o = n.find("col"),
              i = "before" === t ? a : a + 1,
              s = Z(Y.doc.createElement("col"));
            return s.css("width", l.toFixed(4) + "%"), i < o.length ? o.eq(i).before(s) : n.append(s), o.each(function (e) {
              var t = r[e] || l;
              Z(this).css("width", t.toFixed(4) + "%");
            }), n;
          }(e, d, b, r, o), e.find("tr").not(e.find("> table tr")).each(function (e) {
            for (var t, a = Z(this), l = 0, r = 0; l - 1 < b;) {
              if (!(t = a.find("> th, > td").get(r))) {
                t = null;
                break;
              }
              t == p[e][l] ? (l += parseInt(Z(t).attr("colspan"), 10) || 1, r++) : (l += parseInt(Z(p[e][l]).attr("colspan"), 10) || 1, "after" == d && (t = 0 === r ? -1 : a.find("> th, > td").get(r - 1)));
            }
            var n = Z(t);
            if ("after" == d && b < l - 1 || "before" == d && 0 < b && p[e][b] == p[e][b - 1]) {
              if (0 === e || 0 < e && p[e][b] != p[e - 1][b]) {
                var o = parseInt(n.attr("colspan"), 10) + 1;
                n.attr("colspan", o), n.removeData("old-width");
              }
            } else {
              var i,
                s = (n.get(0) || "").tagName;
              if (0 < a.find("th").length && "TH" === s) i = "<th><br></th>";else {
                var c = E(p[e][b]),
                  f = n.attr("style") || "";
                i = "<td".concat(f ? ' style="'.concat(f, '"') : "", ">") + c.startTag + "<br>" + c.closeTag + "</td>";
              }
              Z(i).append("<br>"), -1 == t ? a.prepend(i) : null == t ? a.append(i) : "before" == d ? n.before(i) : "after" == d && n.after(i);
            }
          }), e.find("th, td").each(function () {
            Z(this).removeData("old-width");
          }), Y.popups.isVisible("table.edit") && C();
        }
      },
      deleteColumn: function Me() {
        var e = ve();
        if (0 < e.length) {
          var t,
            a,
            l,
            r = j();
          we(e, r[0].length);
          var n = L(r);
          if (null == n) return;
          if (0 === n.min_j && n.max_j == r[0].length - 1) x();else {
            var o = ye(e);
            for (a = n.max_j; a >= n.min_j; a--) for (t = 0; t < r.length; t++) if (0 === t || r[t][a] != r[t - 1][a]) if (l = Z(r[t][a]), 1 < (parseInt(l.attr("colspan"), 10) || 1)) {
              var i = parseInt(l.attr("colspan"), 10) - 1;
              1 == i ? l.removeAttr("colspan") : l.attr("colspan", i), l.removeData("old-width");
            } else {
              var s = Z(l.parent().get(0));
              l.remove(), 0 === s.find("> th, > td").length && (0 === s.prev().length || 0 === s.next().length || s.prev().find("> th[rowspan], > td[rowspan]").length < s.prev().find("> th, > td").length) && s.remove();
            }
            $(0, r.length - 1, 0, r[0].length - 1, e), function d(e, t, a, l) {
              var r = l.length - (a - t + 1);
              if (0 < r) {
                for (var n = we(e, r), o = 0, i = 0; i < l.length; i++) (i < t || a < i) && (o += l[i]);
                for (var s = [], c = 0; c < l.length; c++) if (c < t || a < c) {
                  var f = 100 * l[c] / o;
                  s.push(f);
                }
                Ee(n, s);
              }
            }(e, n.min_j, n.max_j, o), 0 < n.min_j ? Y.selection.setAtEnd(r[n.min_i][n.min_j - 1]) : Y.selection.setAtEnd(r[n.min_i][0]), Y.selection.restore(), Y.popups.hide("table.edit");
          }
        }
      },
      mergeCells: function $e() {
        if (1 < ge().length && (0 === Y.$el.find("th.fr-selected-cell").length || 0 === Y.$el.find("td.fr-selected-cell").length)) {
          S();
          var e,
            t,
            a = j(),
            l = L(a);
          if (null == l) return;
          var r = Y.$el.find(".fr-selected-cell"),
            n = Z(r[0]),
            o = n.closest("table"),
            i = n.html(),
            s = ye(o);
          for (l.min_j < l.max_j && n.attr("colspan", l.max_j - l.min_j + 1), l.min_i < l.max_i && n.attr("rowspan", l.max_i - l.min_i + 1), e = 1; e < r.length; e++) "<br>" != (t = Z(r[e])).html() && "" !== t.html() && (i += "<br>".concat(t.html())), t.remove();
          n.html(i), Y.selection.setAtEnd(n.get(0)), Y.selection.restore(), Y.toolbar.enable(), H(l.min_i, l.max_i, o);
          var c = o.find("tr:empty");
          for (e = c.length - 1; 0 <= e; e--) Z(c[e]).remove();
          O(l.min_j, l.max_j, o);
          var f = j(o),
            d = f[0] ? f[0].length : 0;
          if (a[0].length > d) {
            var p = o.find("colgroup"),
              b = a[0].map(function (e, t) {
                return Z(e).is(".fr-selected-cell") ? t : null;
              }).filter(function (e) {
                return null !== e;
              }),
              h = b.reduce(function (e, t) {
                return e + s[t];
              }, 0);
            Ee(p, [].concat(Ge(s.slice(0, Math.min.apply(Math, Ge(b)))), [h], Ge(s.slice(Math.max.apply(Math, Ge(b)) + 1))));
          }
          we(o, d), C();
        }
      },
      splitCellVertically: function De() {
        if (1 == ge().length) {
          var e = Y.$el.find(".fr-selected-cell"),
            t = parseInt(e.attr("colspan"), 10) || 1,
            a = e.parent().outerWidth(),
            l = e.outerWidth(),
            r = e.parents("table"),
            n = 0,
            o = e.clone().html("<br>"),
            i = j(),
            s = P(e.get(0), i);
          if (1 < t) n = Math.ceil(t / 2), l = function p(e, t, a) {
            var l,
              r = 0;
            for (l = e; l <= t; l++) r += fe(l, a);
            return r;
          }(s.col, s.col + n - 1, i) / a * 100, 1 < n ? e.attr("colspan", n) : e.removeAttr("colspan"), 1 < t - n ? o.attr("colspan", t - n) : o.removeAttr("colspan");else {
            var c;
            for (c = 0; c < i.length; c++) if (0 === c || i[c][s.col] != i[c - 1][s.col]) {
              var f = Z(i[c][s.col]);
              if (!f.is(e)) {
                var d = (parseInt(f.attr("colspan"), 10) || 1) + 1;
                f.attr("colspan", d);
              }
            }
            l = l / a * 100 / 2;
          }
          e[0].parentNode && e[0].insertAdjacentElement("afterend", o[0]), function b(e, t, a, l, r) {
            var n = e.find("colgroup");
            0 === n.length && (n = we(e, r[0].length));
            var o = n.find("col");
            if (1 < a) {
              var i = ye(e);
              Ee(n, i);
            } else {
              var s = l,
                c = o.eq(t.col);
              c.length && c.css("width", s.toFixed(4) + "%");
              var f = Z(Y.doc.createElement("col"));
              f.css("width", s.toFixed(4) + "%"), t.col + 1 < o.length ? o.eq(t.col + 1).before(f) : n.append(f);
            }
          }(r, s, t, l, i), V(), Y.popups.hide("table.edit");
        }
      },
      splitCellHorizontally: function Se() {
        if (1 == ge().length) {
          var e = Y.$el.find(".fr-selected-cell"),
            t = e.parent(),
            a = e.closest("table"),
            l = parseInt(e.attr("rowspan"), 10),
            r = j(),
            n = P(e.get(0), r),
            o = e.clone().html("<br>");
          if (1 < l) {
            var i = Math.ceil(l / 2);
            1 < i ? e.attr("rowspan", i) : e.removeAttr("rowspan"), 1 < l - i ? o.attr("rowspan", l - i) : o.removeAttr("rowspan");
            for (var s = n.row + i, c = 0 === n.col ? n.col : n.col - 1; 0 <= c && (r[s][c] == r[s][c - 1] || 0 < s && r[s][c] == r[s - 1][c]);) c--;
            -1 == c ? Z(a.find("tr").not(a.find("> table tr")).get(s)).prepend(o) : Z(r[s][c])[0].parentNode && Z(r[s][c])[0].insertAdjacentElement("afterend", o[0]);
          } else {
            var f,
              d = Z(document.createElement("tr")).append(o);
            for (f = 0; f < r[0].length; f++) if (0 === f || r[n.row][f] != r[n.row][f - 1]) {
              var p = Z(r[n.row][f]);
              p.is(e) || p.attr("rowspan", (parseInt(p.attr("rowspan"), 10) || 1) + 1);
            }
            t[0].parentNode && t[0].insertAdjacentElement("afterend", d[0]);
          }
          V(), Y.popups.hide("table.edit");
        }
      },
      addHeader: function Ve() {
        var e = ve();
        if (0 < e.length && 0 === e.find("> th").length) {
          var t,
            a = "<thead><tr>",
            l = 0;
          for (l = e.find("tr").first().find("> th").length, e.find("tr").first().find("> td").each(function () {
            var e = Z(this);
            l += parseInt(e.attr("colspan"), 10) || 1;
          }), t = 0; t < l; t++) a += "<th><br></th>";
          a += "</tr></thead>", e.prepend(a), C();
        }
      },
      addFooter: function Ne() {
        var e = ve();
        if (0 < e.length && 0 === e.find("tfoot").length) {
          var t = "<tfoot><tr>",
            a = 0,
            l = e.find("thead tr").first();
          0 === l.length && (l = e.find("tbody tr").first()), l.find("th, td").each(function () {
            a += parseInt(Z(this).attr("colspan"), 10) || 1;
          });
          for (var r = 0; r < a; r++) t += "<td><br></td>";
          t += "</tr></tfoot>", e.append(t), C();
        }
      },
      removeHeader: function Le() {
        var e = ve(),
          t = e.find("> thead");
        if (0 < (t = Z(t)).length) if (0 === e.find("tbody tr").length) x();else if (t.remove(), 0 < ge().length) C();else {
          Y.popups.hide("table.edit");
          var a = e.find("tbody tr").first().find("td").first().get(0);
          a && (Y.selection.setAtEnd(a), Y.selection.restore());
        }
      },
      removeFooter: function _e() {
        var e = ve(),
          t = e.find("tfoot");
        if (0 < t.length) if (0 === e.find("tbody tr").length) x();else if (t.remove(), 0 < ge().length) C();else {
          Y.popups.hide("table.edit");
          var a = e.find("tbody tr").first().find("td").first().get(0);
          a && (Y.selection.setAtEnd(a), Y.selection.restore());
        }
      },
      setBackground: function a(e) {
        var t = Y.$el.find(".fr-selected-cell");
        "REMOVE" != e ? t.css("background-color", Y.helpers.HEXtoRGB(e)) : t.css("background-color", "");
      },
      showInsertPopup: function Ie() {
        var e = Y.$tb.find('.fr-command[data-cmd="insertTable"]'),
          t = Y.popups.get("table.insert");
        if (t || (t = n()), !t.hasClass("fr-active")) {
          Y.popups.refresh("table.insert"), Y.popups.setContainer("table.insert", Y.$tb);
          var a = Y.button.getPosition(e),
            l = a.left,
            r = a.top;
          Y.popups.show("table.insert", l, r, e.outerHeight());
        }
      },
      showEditPopup: C,
      showColorsPopup: function Pe(e) {
        var t = j();
        if (t) {
          var a = Y.popups.get("table.colors");
          a || (a = function i() {
            var e = "",
              t = 0;
            0 < Y.opts.tableColorsButtons.length && (e = '<div class="fr-buttons fr-colors-buttons fr-tabs">'.concat(Y.button.buildList(Y.opts.tableColorsButtons), "</div>"));
            var a = "";
            Y.opts.colorsHEXInput && (a = '<div class="fr-color-hex-layer fr-table-colors-hex-layer fr-active fr-layer" id="fr-table-colors-hex-layer-'.concat(Y.id, '">\n        <div class="fr-input-line">\n        <input maxlength="7" id="fr-table-colors-hex-layer-text" tabIndex="').concat(++t, '" type="text" placeholder="').concat(Y.language.translate("HEX Color"), '" aria-required="true">\n        </div>\n        <div class="fr-action-buttons">\n        <button type="button" class="fr-command fr-submit" tabIndex="').concat(++t, '" data-cmd="applyCustomColor" role="button">\n        ').concat(Y.language.translate("OK"), "\n        </button>\n        </div>\n        </div>"));
            var l = {
                buttons: e,
                colors: function n() {
                  for (var e = '<div class="fr-color-set fr-table-colors">', t = 0; t < Y.opts.tableColors.length; t++) 0 !== t && t % Y.opts.tableColorsStep == 0 && (e += "<br>"), "REMOVE" != Y.opts.tableColors[t] ? e += '<span class="fr-command fr-select-color" style="background: '.concat(Y.opts.tableColors[t], ';" tabIndex="-1" aria-selected="false" role="button" data-cmd=\'onSelectColor\' data-param1="').concat(Y.opts.tableColors[t], '"><span class="fr-sr-only">').concat(Y.language.translate("Color"), " ").concat(Y.opts.tableColors[t], "&nbsp;&nbsp;&nbsp;</span></span>") : e += '<span class="fr-command fr-select-color" data-cmd=\'onColorClear\' tabIndex="-1" role="button" title="'.concat(Y.language.translate("Clear Formatting"), '">').concat(Y.icon.create("tableColorRemove"), '<span class="fr-sr-only">').concat(Y.language.translate("Clear Formatting"), "</span></span>");
                  return e += "</div>";
                }(),
                custom_color: a
              },
              r = Y.popups.create("table.colors", l);
            return function o(m) {
              Y.events.on("popup.tab", function (e) {
                var t = Z(e.currentTarget);
                if (!Y.popups.isVisible("table.colors") || !t.is("span, input, button")) return !0;
                var a,
                  l,
                  r = e.which,
                  n = !0;
                if (je.KEYCODE.TAB == r) {
                  var o = m.find("span.fr-select-color");
                  if (t.is(o.first()) && e.shiftKey || t.is(m.find("span.fr-submit")) && !e.shiftKey) {
                    var i = m.find(".fr-buttons");
                    n = !Y.accessibility.focusToolbar(i, !!e.shiftKey);
                  }
                  if (!1 !== n) {
                    var s = m.find("span.fr-select-color");
                    s.add(m.find("input")), s.add(m.find("button.fr-submit")), a = s.index(t), a = e.shiftKey ? ((a - 1) % s.length + s.length) % s.length : (a + 1) % s.length, l = s.get(a), Y.events.disableBlur(), l.focus(), n = !1;
                  }
                } else if (je.KEYCODE.ARROW_UP == r || je.KEYCODE.ARROW_DOWN == r || je.KEYCODE.ARROW_LEFT == r || je.KEYCODE.ARROW_RIGHT == r) {
                  var c = t.parent().find("span.fr-command"),
                    f = c.index(t),
                    d = Y.opts.colorsStep,
                    p = Math.floor(c.length / d),
                    b = f % d,
                    h = Math.floor(f / d),
                    u = h * d + b,
                    g = p * d;
                  je.KEYCODE.ARROW_UP == r ? u = ((u - d) % g + g) % g : je.KEYCODE.ARROW_DOWN == r ? u = (u + d) % g : je.KEYCODE.ARROW_LEFT == r ? u = ((u - 1) % g + g) % g : je.KEYCODE.ARROW_RIGHT == r && (u = (u + 1) % g);
                  var v = Z(c.get(u));
                  Y.events.disableBlur(), v.focus(), n = !1;
                } else je.KEYCODE.ENTER == r && (Y.button.exec(t), n = !1);
                return !1 === n && (e.preventDefault(), e.stopPropagation()), n;
              }, !0);
            }(r), r;
          }()), a.data("type", e), Y.popups.setContainer("table.colors", Y.$sc);
          var l = _(t),
            r = (l.left + l.right) / 2,
            n = l.bottom;
          !function o() {
            var e = Y.popups.get("table.colors"),
              t = Y.$el.find(".fr-selected-cell").first(),
              a = Y.helpers.RGBToHex(t.css("background-color")),
              l = e.find(".fr-table-colors-hex-layer input");
            e.find(".fr-selected-color").removeClass("fr-selected-color fr-active-item"), e.find('span[data-param1="'.concat(a, '"]')).addClass("fr-selected-color fr-active-item"), l.val("");
          }(), Y.popups.show("table.colors", r, n, l.bottom - l.top, !0);
        }
      },
      showTableProperties: function ke() {
        var e = j();
        if (e) {
          var n = Y.popups.get("table.tableProperties");
          n || (n = Ce());
          var t = ve();
          n.data("tableStyle", {}), n.data("borderStyle", "");
          var a = t[0],
            l = a && a.getAttribute("style") || "",
            r = !!l,
            o = r && /background(-color)?\s*:/i.test(l) ? t.css("background-color") : "",
            i = r && /border(-color)?\s*:/i.test(l) ? t.css("border-color") : "",
            s = r && /border(-style)?\s*:/i.test(l) ? t.css("border-style") : "",
            c = r && /border(-width)?\s*:/i.test(l) ? t[0].style.borderWidth : "",
            f = r && /(^|\s|;)width\s*:/i.test(l) && a ? a.style.width : "",
            d = r && /(^|\s|;)height\s*:/i.test(l) && a ? a.style.height : "",
            p = r ? /\bfloat\s*:\s*right\b/i.test(l) ? "right" : /\bfloat\s*:\s*left\b/i.test(l) ? "left" : /\bmargin\s*:\s*auto\b/i.test(l) ? "center" : "left" : "left",
            b = "",
            h = {};
          if (t.is("[class]")) {
            var u = t.attr("class").split(/\s+/),
              g = Y.opts.tableStyles;
            h = u.reduce(function (e, t) {
              return g.hasOwnProperty(t) && (e[t] = g[t]), e;
            }, {}), b = Object.values(h).join(", ");
          }
          var v = function v(e, t, a, l) {
              var r = Y.helpers.isRGBColor(l) ? Y.helpers.RGBToHex(l) : l;
              n.find(e).val(r), T(n.find(t), n.find(a), r);
            },
            m = n.find(".fr-border-style").find(".fr-dropdown"),
            C = n.find(".fr-table-style").find(".fr-dropdown");
          v("#fr-table-bg", ".fr-color-preview", ".fr-color-preview-indicator", o), v("#fr-table-border-color", ".fr-border-color-preview", ".fr-border-color-preview-indicator", i), m.find("> span").text(s), C.find("> span").text(b || " "), me(p), setTimeout(function () {
            c && n.find("#fr-table-border-width").val(c).focus(), i && n.find("#fr-table-border-color").focus(), f && n.find("#fr-table-width").val(f).focus(), d && n.find("#fr-table-height").val(d).focus(), s && n.data("borderStyle", s), h && n.data("tableStyle", h), n.find("#fr-table-bg").focus();
          }, 10), Y.popups.setContainer("table.tableProperties", Y.$sc);
          var w = _(e),
            y = (w.left + w.right) / 2,
            E = w.bottom;
          Y.popups.show("table.tableProperties", y, E, w.bottom - w.top, !0);
        }
      },
      hideTableProperties: function Be() {
        Y.popups.hide("table.tableProperties");
      },
      updateTableAlign: me,
      back: function Fe(e) {
        if (e && Y.popups.isVisible("table.colors")) {
          Y.popups.hide("table.colors");
          var t = j();
          if (t) {
            var a = "table" === e || "border" === e,
              l = a ? "table.tableProperties" : "table.cellProperties",
              r = Y.popups.get(l);
            r || (r = a ? Ce() : m()), Y.popups.setContainer(l, Y.$sc);
            var n,
              o = _(t),
              i = o.left + (o.right - o.left) / 2,
              s = o.bottom;
            Y.popups.show(l, i, s, o.bottom - o.top, !0), n = "table" === e ? ".fr-btn-table-bg-color" : "border" === e ? ".fr-btn-table-border-bg-color" : ".fr-btn-cell-bg-color", r.find(n).focus();
          }
        } else 0 < ge().length ? C() : (Y.popups.hide("table.insert"), Y.toolbar.showInline());
      },
      verticalAlign: function ze(e) {
        Y.$el.find(".fr-selected-cell").css("vertical-align", e);
      },
      horizontalAlign: function Ke(e) {
        var t = Y.$el.find(".fr-selected-cell");
        t.css("text-align", e), t.children().css("text-align", "");
      },
      applyStyle: function Ye(e, t, a, l) {
        if (0 < t.length) {
          if (Y.opts.useClasses || ("TABLE" === t.get(0).tagName ? function n(e, t) {
            var a = e.childNodes;
            if (0 < a.length) for (var l = 0; l < a.length; l++) "TD" === a[l].tagName ? "fr-dashed-borders" === t || "fr-highlighted" === t || "fr-thick" === t ? D(a[l]) : "fr-alternate-rows" === t && a[l].style.removeProperty("background-color") : n(a[l], t);
          }(t.get(0), e) : D(t.get(0))), !a) {
            var r = Object.keys(l);
            r.splice(r.indexOf(e), 1), t.removeClass(r.join(" "));
          }
          t.toggleClass(e);
        }
      },
      selectedTable: ve,
      selectedCells: ge,
      customColor: function We() {
        var e = Y.popups.get("table.colors").find(".fr-table-colors-hex-layer input"),
          t = e.val(),
          a = t;
        t && t.length && (0 !== t.indexOf("#") && (a = "#" + t), v(a)), e.val("");
      },
      selectCells: I,
      resetAll: w,
      showCellPropertiesPopup: function Ze() {
        var e = j();
        if (e) {
          var t = Y.popups.get("table.cellProperties") || m();
          t.find("#fr-cell-bg, #fr-cell-width, #fr-cell-height, #fr-cell-padding").val(""), w(), T(t.find(".fr-color-preview"), t.find(".fr-color-preview-indicator"), "");
          var a = Y.table.selectedCells();
          if (a.length) {
            var s = null,
              c = !0,
              f = null,
              d = !0,
              p = null,
              b = !0,
              h = null,
              u = !0,
              n = function n(e) {
                return "rgba(0, 100, 255, 0.15)" === e;
              };
            Array.from(a).forEach(function (e, t) {
              var a,
                l = Z(e),
                r = l.css("background-color");
              r && "rgba(0, 0, 0, 0)" !== r && "transparent" !== r && (a = Y.helpers.RGBToHex(r));
              var n = l.attr("data-cell-width"),
                o = l.attr("data-cell-height"),
                i = l.attr("data-cell-padding");
              0 === t ? (f = n || null, p = o || null, h = i || null, s = a || null) : (n !== f && (d = !1), o !== p && (b = !1), i !== h && (u = !1), a !== s && (c = !1));
            });
            var l = "";
            if (1 === a.length) {
              var r = Z(a[0]),
                o = r.css("background-color");
              !(r[0] && r[0].hasAttribute("style") && /background(-color)?:/i.test(r.attr("style"))) && n(o) || (l = Y.helpers.isRGBColor(o) ? Y.helpers.RGBToHex(o) : o);
            } else c && s && Array.from(a).every(function (e) {
              var t = Z(e),
                a = e.getAttribute("style") || "",
                l = /background(-color)?:/i.test(a),
                r = t.css("background-color");
              return l || !n(r);
            }) && (l = Y.helpers.isRGBColor(s) ? Y.helpers.RGBToHex(s) : s);
            t.find("#fr-cell-bg").val(l), T(t.find(".fr-color-preview"), t.find(".fr-color-preview-indicator"), l), d && f && t.find("#fr-cell-width").val(f), b && p && t.find("#fr-cell-height").val(p), u && h && t.find("#fr-cell-padding").val(h), Y.popups.setContainer("table.cellProperties", Y.$sc);
            var i = _(e),
              g = i.left + (i.right - i.left) / 2,
              v = i.bottom;
            Y.popups.show("table.cellProperties", g, v, i.bottom - i.top, !0);
          }
        }
      },
      updateSelectedColor: v
    };
  }, je.RegisterCommand("tableProperties", {
    title: "Table Properties",
    icon: "tablePropertiesIcon",
    undo: !1,
    focus: !1,
    popup: !0,
    callback: function () {
      this.table.showTableProperties();
    }
  }), je.RegisterCommand("openColorPicker", {
    title: "Select color",
    focus: !1,
    popup: !0,
    callback: function (e, t) {
      this.table.showColorsPopup(t);
    }
  }), je.RegisterCommand("onCancel", {
    title: "Cancel",
    callback: function () {
      this.popups.hide("table.tableProperties"), this.popups.hide("table.cellProperties"), this.table.showEditPopup();
    }
  }), je.RegisterCommand("applyCustomColor", {
    title: "OK",
    undo: !0,
    callback: function () {
      var e = this.popups.get("table.colors");
      this.table.back(e.data("type")), this.table.customColor();
    }
  }), je.RegisterCommand("onSelectColor", {
    undo: !0,
    focus: !1,
    callback: function (e, t) {
      var a = this.popups.get("table.colors");
      this.table.back(a.data("type")), this.table.updateSelectedColor(t);
    }
  }), je.RegisterCommand("tableAlign", {
    title: "Table Align",
    undo: !0,
    callback: function (e, t) {
      this.table.updateTableAlign(t);
    }
  }), je.RegisterCommand("tableBorderStyle", {
    title: "",
    type: "dropdown",
    focus: !0,
    undo: !0,
    refreshAfterCallback: !0,
    displaySelection: function (e) {
      return e.opts.tableBorderStyle;
    },
    html: function () {
      for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.tableBorderStyle, a = 0; a < t.length; a++) e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableBorderStyle" data-param1="'.concat(t[a], '" title="').concat(t[a], '">').concat(t[a], "</a></li>");
      return e += "</ul>";
    },
    callback: function (e, t) {
      var a = this.popups.get("table.tableProperties"),
        l = a.find(".fr-border-style").find(".fr-dropdown");
      l.find("> span").text(t), a.data("borderStyle", t), l.focus();
    },
    refreshOnShow: function (e, t) {
      var a = this.popups.get("table.tableProperties").data("borderStyle");
      t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected", !1), t.find('.fr-command[data-param1="'.concat(a, '"]')).addClass("fr-active").attr("aria-selected", !0);
    }
  }), je.RegisterCommand("tableStyle", {
    title: "",
    type: "dropdown",
    focus: !0,
    undo: !0,
    displaySelectionWidth: "300",
    refreshAfterCallback: !0,
    displaySelection: function (e) {
      return e.opts.tableStyles;
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = this.opts.tableStyles;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableStyle" data-param1="'.concat(a, '" title="').concat(this.language.translate(t[a]), '">').concat(this.language.translate(t[a]), "</a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      var a = this.popups.get("table.tableProperties"),
        l = a.find(".fr-table-style").find(".fr-dropdown"),
        r = this.opts.tableStyles,
        n = a.data("tableStyle") || {};
      n[t] ? delete n[t] : n[t] = r[t], a.data("tableStyle", n);
      var o = Object.keys(n).length ? Object.values(n).join(", ") : " ";
      l.find("> span").text(o), l.focus();
    },
    refreshOnShow: function (e, t) {
      var r = this,
        a = this.$el.find(".fr-selected-cell").closest("table"),
        n = this.popups.get("table.tableProperties");
      a && t.find(".fr-command").each(function (e, t) {
        var a = r.$(t).data("param1"),
          l = n.data("tableStyle") && n.data("tableStyle")[a];
        l && r.$(t).toggleClass("fr-active", l).attr("aria-selected", l);
      });
    }
  }), je.RegisterCommand("onColorClear", {
    undo: !0,
    focus: !1,
    callback: function () {
      var e = this.popups.get("table.colors");
      this.table.back(e.data("type")), e.find("#fr-table-colors-hex-layer-text").val(""), this.table.updateSelectedColor("");
    }
  }), je.RegisterCommand("applyTableProperties", {
    title: "Apply Table Properties",
    undo: !0,
    focus: !0,
    callback: function () {
      var e = this.popups.get("table.tableProperties"),
        t = e.find("#fr-table-bg").val(),
        a = e.find("#fr-table-border-color").val(),
        l = this.table.selectedTable(),
        r = e.find("#fr-table-width").val(),
        n = e.find("#fr-table-height").val(),
        o = e.find("#fr-table-border-width").val(),
        i = e.data("borderStyle"),
        s = e.data("tableAlign"),
        c = e.data("tableStyle"),
        f = !t || "REMOVE" === t || "transparent" === t || "rgba(0, 0, 0, 0)" === t;
      l.css("background-color", f ? "" : t);
      var d = !a || "REMOVE" === a || "transparent" === a || "rgba(0, 0, 0, 0)" === a;
      l.css("border-color", d ? "" : a);
      var p = function p(e) {
        if ("" === e) return !0;
        var t = e.trim();
        return /^-?\d+(\.\d+)?$/.test(t) && (t += "px"), /^-?\d+(\.\d+)?(px|%)$/.test(t) ? t : null;
      };
      if (r && p(r) ? l.css("width", p(r)) : l.css("width", ""), n && p(n) ? l.css("height", p(n)) : l.css("height", ""), o && p(o) ? l.css("border-width", p(o)) : l.css("border-width", ""), i && l.css("border-style", i), "center" === s ? (l.css("margin", "auto"), l.css("float", "")) : (l.parent().is("li") && l.parent().css("display", "list-item flow-root"), l.css("float", s), l.css("margin", "")), l.removeAttr("class"), c && 0 < Object.keys(c).length) for (var b in c) c.hasOwnProperty(b) && l.addClass(b);
      this.popups.hide("table.tableProperties");
    }
  }), je.RegisterCommand("tableCellProperties", {
    title: "Cell Properties",
    icon: "tableCellProperties",
    undo: !1,
    focus: !1,
    popup: !0,
    callback: function () {
      this.table.showCellPropertiesPopup();
    },
    refresh: function (e) {
      var t = 0 < this.table.selectedCells().length;
      e.toggleClass("fr-disabled", !t).attr("aria-disabled", !t);
    }
  }), je.RegisterCommand("applyCellProperties", {
    title: "Apply Cell Properties",
    undo: !0,
    focus: !1,
    callback: function () {
      var n = this.$,
        e = this.popups.get("table.cellProperties"),
        o = function o(e, t, a, l) {
          var r = n(e);
          a ? (l && r.attr(l, a), a !== r[0].style[t] && (["width", "height"].includes(t) && r.removeAttr(t), r.css(t, a))) : (r.css(t, ""), l && r.removeAttr(l), ["width", "height"].includes(t) && r.removeAttr(t));
        },
        r = e.find("#fr-cell-bg").val(),
        i = e.find("#fr-cell-width").val(),
        s = e.find("#fr-cell-height").val(),
        c = e.find("#fr-cell-padding").val(),
        f = !0 === e.data("bg-modified"),
        d = !0 === e.data("width-modified"),
        p = !0 === e.data("height-modified"),
        b = !0 === e.data("padding-modified");
      this.table.selectedCells().forEach(function (e) {
        var t = n(e);
        if (f) {
          var a = !r || "REMOVE" === r || "transparent" === r || "rgba(0, 0, 0, 0)" === r;
          t.css("background-color", a ? "" : r);
        }
        var l = function l(e) {
          if ("" === e) return !0;
          var t = e.trim();
          return /^-?\d+(\.\d+)?$/.test(t) && (t += "px"), /^-?\d+(\.\d+)?(px|%)$/.test(t) ? t : null;
        };
        d && l(i) && o(e, "width", i, "data-cell-width"), p && l(s) && o(e, "height", s, "data-cell-height"), b && l(c) && o(e, "padding", c, "data-cell-padding");
      }), this.table.resetAll(), this.popups.hide("table.cellProperties");
    }
  }), je.DefineIcon("insertTable", {
    NAME: "table",
    SVG_KEY: "insertTable"
  }), je.RegisterCommand("insertTable", {
    title: "Insert Table",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("table.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("table.insert")) : this.table.showInsertPopup();
    },
    plugin: "table"
  }), je.RegisterCommand("tableInsert", {
    callback: function (e, t, a) {
      this.table.insert(t, a), this.popups.hide("table.insert");
    }
  }), je.DefineIcon("tableHeader", {
    NAME: "header",
    FA5NAME: "heading",
    SVG_KEY: "tableHeader"
  }), je.RegisterCommand("tableHeader", {
    title: "Table Header",
    focus: !1,
    toggle: !0,
    callback: function () {
      this.popups.get("table.edit").find('.fr-command[data-cmd="tableHeader"]').hasClass("fr-active") ? this.table.removeHeader() : this.table.addHeader();
    },
    refresh: function (e) {
      var t = this.table.selectedTable();
      0 < t.length && (0 === t.find("> thead").length ? e.removeClass("fr-active").attr("aria-pressed", !1) : e.addClass("fr-active").attr("aria-pressed", !0));
    }
  }), je.DefineIcon("tableFooter", {
    NAME: "table",
    FA5NAME: "table",
    SVG_KEY: "tableFooter"
  }), je.RegisterCommand("tableFooter", {
    title: "Table Footer",
    focus: !1,
    toggle: !0,
    callback: function () {
      this.popups.get("table.edit").find('.fr-command[data-cmd="tableFooter"]').hasClass("fr-active") ? this.table.removeFooter() : this.table.addFooter();
    },
    refresh: function (e) {
      var t = this.table.selectedTable();
      0 < t.length && (0 === t.find("tfoot").length ? e.removeClass("fr-active").attr("aria-pressed", !1) : e.addClass("fr-active").attr("aria-pressed", !0));
    }
  }), je.DefineIcon("tableRows", {
    NAME: "bars",
    SVG_KEY: "row"
  }), je.RegisterCommand("tableRows", {
    type: "dropdown",
    focus: !1,
    title: "Row",
    options: {
      above: "Insert row above",
      below: "Insert row below",
      "delete": "Delete row"
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = je.COMMANDS.tableRows.options;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableRows" data-param1="' + a + '" title="' + this.language.translate(t[a]) + '">' + this.language.translate(t[a]) + "</a></li>");
      return e += "</ul>";
    },
    callback: function (e, t) {
      "above" == t || "below" == t ? this.table.insertRow(t) : this.table.deleteRow();
    }
  }), je.DefineIcon("tableColumns", {
    NAME: "bars fa-rotate-90",
    SVG_KEY: "columns"
  }), je.RegisterCommand("tableColumns", {
    type: "dropdown",
    focus: !1,
    title: "Column",
    options: {
      before: "Insert column before",
      after: "Insert column after",
      "delete": "Delete column"
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = je.COMMANDS.tableColumns.options;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableColumns" data-param1="'.concat(a, '" title="').concat(this.language.translate(t[a]), '">').concat(this.language.translate(t[a]), "</a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      "before" == t || "after" == t ? this.table.insertColumn(t) : this.table.deleteColumn();
    }
  }), je.DefineIcon("tableCells", {
    NAME: "square-o",
    FA5NAME: "square",
    SVG_KEY: "cellOptions"
  }), je.RegisterCommand("tableCells", {
    type: "dropdown",
    focus: !1,
    title: "Cell",
    options: {
      merge: "Merge cells",
      "vertical-split": "Vertical split",
      "horizontal-split": "Horizontal split"
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = je.COMMANDS.tableCells.options;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCells" data-param1="'.concat(a, '" title="').concat(this.language.translate(t[a]), '">').concat(this.language.translate(t[a]), "</a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      "merge" == t ? this.table.mergeCells() : "vertical-split" == t ? this.table.splitCellVertically() : this.table.splitCellHorizontally();
    },
    refreshOnShow: function (e, t) {
      1 < this.$el.find(".fr-selected-cell").length ? (t.find('a[data-param1="vertical-split"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="horizontal-split"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="merge"]').removeClass("fr-disabled").attr("aria-disabled", !1)) : (t.find('a[data-param1="merge"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="vertical-split"]').removeClass("fr-disabled").attr("aria-disabled", !1), t.find('a[data-param1="horizontal-split"]').removeClass("fr-disabled").attr("aria-disabled", !1));
    }
  }), je.DefineIcon("tableRemove", {
    NAME: "trash",
    SVG_KEY: "removeTable"
  }), je.RegisterCommand("tableRemove", {
    title: "Remove Table",
    focus: !1,
    callback: function () {
      this.table.remove();
    }
  }), je.DefineIcon("tableBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), je.RegisterCommand("tableBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      var e = this.popups.get("table.colors");
      this.table.back(e && e.length ? e.data("type") : null);
    }
  }), je.DefineIcon("tableCellVerticalAlign", {
    NAME: "arrows-v",
    FA5NAME: "arrows-alt-v",
    SVG_KEY: "verticalAlignMiddle"
  }), je.RegisterCommand("tableCellVerticalAlign", {
    type: "dropdown",
    focus: !1,
    title: "Vertical Align",
    options: {
      Top: "Align Top",
      Middle: "Align Middle",
      Bottom: "Align Bottom"
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = je.COMMANDS.tableCellVerticalAlign.options;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellVerticalAlign" data-param1="'.concat(a.toLowerCase(), '" title="').concat(this.language.translate(t[a]), '">').concat(this.language.translate(a), "</a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      this.table.verticalAlign(t);
    },
    refreshOnShow: function (e, t) {
      t.find('.fr-command[data-param1="' + this.$el.find(".fr-selected-cell").css("vertical-align") + '"]').addClass("fr-active").attr("aria-selected", !0);
    }
  }), je.DefineIcon("tableCellHorizontalAlign", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), je.DefineIcon("align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), je.DefineIcon("align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }), je.DefineIcon("align-center", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }), je.DefineIcon("align-justify", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }), je.RegisterCommand("tableCellHorizontalAlign", {
    type: "dropdown",
    focus: !1,
    title: "Horizontal Align",
    options: {
      left: "Align Left",
      center: "Align Center",
      right: "Align Right",
      justify: "Align Justify"
    },
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = je.COMMANDS.tableCellHorizontalAlign.options;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="tableCellHorizontalAlign" data-param1="'.concat(a, '" title="').concat(this.language.translate(t[a]), '">').concat(this.icon.create("align-".concat(a)), '<span class="fr-sr-only">').concat(this.language.translate(t[a]), "</span></a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      this.table.horizontalAlign(t);
    },
    refresh: function (e) {
      var t = this.table.selectedCells(),
        a = this.$;
      t.length && e.find("> *").first().replaceWith(this.icon.create("align-".concat(this.helpers.getAlignment(a(t[0])))));
    },
    refreshOnShow: function (e, t) {
      t.find('.fr-command[data-param1="' + this.helpers.getAlignment(this.$el.find(".fr-selected-cell").first()) + '"]').addClass("fr-active").attr("aria-selected", !0);
    }
  }), je.DefineIcon("tableCellStyle", {
    NAME: "magic",
    SVG_KEY: "cellStyle"
  }), je.RegisterCommand("tableCellStyle", {
    title: "Cell Style",
    type: "dropdown",
    focus: !1,
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">',
        t = this.opts.tableCellStyles;
      for (var a in t) t.hasOwnProperty(a) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellStyle" data-param1="'.concat(a, '" title="').concat(this.language.translate(t[a]), '">').concat(this.language.translate(t[a]), "</a></li>"));
      return e += "</ul>";
    },
    callback: function (e, t) {
      this.table.applyStyle(t, this.$el.find(".fr-selected-cell"), this.opts.tableCellMultipleStyles, this.opts.tableCellStyles);
    },
    refreshOnShow: function (e, t) {
      var a = this.$,
        l = this.$el.find(".fr-selected-cell").first();
      l && t.find(".fr-command").each(function () {
        var e = a(this).data("param1"),
          t = l.hasClass(e);
        a(this).toggleClass("fr-active", t).attr("aria-selected", t);
      });
    }
  }), je.DefineIcon("tableColorRemove", {
    NAME: "eraser",
    SVG_KEY: "remove"
  }), je.DefineIcon("tableCellProperties", {
    template: "svgMultiplePath",
    PATHS: '\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.513 3.25C20.9736 3.25 22.1577 4.43408 22.1577 5.89471V12.6517L22.1546 12.6526C21.8784 12.4577 21.6084 12.2933 21.3448 12.1593C21.1821 12.0767 21.0123 11.9963 20.8353 11.9183V8.53928H15.546V12.2584C15.3417 12.3719 15.1339 12.5033 14.9223 12.6526L12.7375 11.9949L11.6254 13.8287H8.93418V16.4735H12.9027C12.893 16.6127 12.8882 16.7519 12.8882 16.891C12.8882 17.1927 12.911 17.4943 12.9565 17.7959H3.64471C2.18408 17.7959 1 16.6118 1 15.1512V5.89471C1 4.43408 2.18408 3.25 3.64471 3.25H19.513ZM19.513 4.57235H15.546V7.21692H20.8353V5.89471C20.8353 5.16439 20.2433 4.57235 19.513 4.57235ZM8.93418 4.57235H14.2236V7.21692H8.93418V4.57235ZM3.64471 4.57235H7.61183V7.21692H2.32235V5.89471C2.32235 5.16439 2.91439 4.57235 3.64471 4.57235ZM2.32235 12.5063V8.53928H7.61183V12.5063H2.32235ZM2.32235 15.1512V13.8287H7.61183V16.4735H3.64471C2.91439 16.4735 2.32235 15.8815 2.32235 15.1512Z" fill="#333333"/>\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.102 20.6423L17.4335 22.25H19.6434L19.9749 20.6423C20.1959 20.553 20.4031 20.4592 20.5964 20.361C20.7898 20.2627 20.9878 20.1421 21.1903 19.9992L22.7925 20.4815L23.8974 18.6595L22.6268 17.5877C22.6636 17.3555 22.682 17.1232 22.682 16.891C22.682 16.6588 22.6636 16.4266 22.6268 16.1944L23.8974 15.1226L22.7925 13.3005L21.1903 13.7828C20.9878 13.6399 20.7898 13.5193 20.5964 13.4211C20.4031 13.3228 20.1959 13.2291 19.9749 13.1397L19.6434 11.5321H17.4335L17.102 13.1397C16.881 13.2291 16.6739 13.3228 16.4805 13.4211C16.2871 13.5193 16.0892 13.6399 15.8866 13.7828L14.2844 13.3005L13.1795 15.1226L14.4502 16.1944C14.4133  16.4266 14.3949 16.6588 14.3949 16.891C14.3949 17.1232 14.4133 17.3555 14.4502 17.5877L13.1795 18.6595L14.2844 20.4815L15.8866 19.9992C16.0892 20.1421 16.2871 20.2627 16.4805 20.361C16.6739 20.4592 16.881 20.553 17.102 20.6423ZM20.0992 18.4049C19.6664 18.8247 19.1462 19.0346 18.5385 19.0346C17.9307  19.0346 17.4105 18.8247 16.9777 18.4049C16.545 17.9851 16.3286 17.4805 16.3286 16.891C16.3286 16.3015 16.545 15.7969 16.9777 15.3771C17.4105 14.9573 17.9307 14.7474 18.5385 14.7474C19.1462 14.7474 19.6664 14.9573 20.0992 15.3771C20.532 15.7969 20.7483 16.3015 20.7483 16.891C20.7483 17.4805 20.532 17.9851 20.0992 18.4049Z" fill="#333333"/>\n  '
  }), je.DefineIcon("tablePropertiesIcon", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.1577 5.89471C22.1577 4.43408 20.9736 3.25 19.513 3.25H3.64471C2.18408 3.25 1 4.43408 1 5.89471V15.1512C1 16.6118 2.18408 17.7959 3.64471 17.7959H12.9565C12.911 17.4943 12.8882 17.1927 12.8882 16.891C12.8882 16.7519 12.893 16.6127 12.9027 16.4735H8.93418V13.8287H11.6254L12.4273 12.5063H8.93418V8.53928H14.2236V12.4422L14.9223 12.6526C15.1339 12.5033 15.3417 12.3719 15.546 12.2584V8.53928H20.8353V11.9183C21.0123 11.9963 21.1821 12.0767 21.3448 12.1593C21.6084 12.2933 21.8784 12.4577 22.1546 12.6526L22.1577 12.6517V5.89471ZM15.546 4.57235H19.513C20.2433 4.57235 20.8353 5.16439 20.8353 5.89471V7.21692H15.546V4.57235ZM14.2236 4.57235H8.93418V7.21692H14.2236V4.57235ZM7.61183 4.57235H3.64471C2.91439 4.57235 2.32235 5.16439 2.32235 5.89471V7.21692H7.61183V4.57235ZM2.32235 8.53928V12.5063H7.61183V8.53928H2.32235ZM2.32235 13.8287V15.1512C2.32235 15.8815 2.91439 16.4735 3.64471 16.4735H7.61183V13.8287H2.32235Z" fill="#333333"/>\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.102 20.6423L17.4335 22.25H19.6434L19.9749 20.6423C20.1959 20.553 20.4031 20.4592 20.5964 20.361C20.7898 20.2627 20.9878 20.1421 21.1903 19.9992L22.7925 20.4815L23.8974 18.6595L22.6268 17.5877C22.6636 17.3555 22.682 17.1232 22.682 16.891C22.682 16.6588 22.6636 16.4266 22.6268 16.1944L23.8974 15.1226L22.7925 13.3005L21.1903 13.7828C20.9878 13.6399 20.7898 13.5193 20.5964 13.4211C20.4031 13.3228 20.1959 13.2291 19.9749 13.1397L19.6434 11.5321H17.4335L17.102 13.1397C16.881 13.2291 16.6739 13.3228 16.4805 13.4211C16.2871 13.5193 16.0892 13.6399 15.8866 13.7828L14.2844 13.3005L13.1795 15.1226L14.4502 16.1944C14.4133 16.4266 14.3949 16.6588 14.3949 16.891C14.3949 17.1232 14.4133 17.3555 14.4502 17.5877L13.1795 18.6595L14.2844 20.4815L15.8866 19.9992C16.0892 20.1421 16.2871 20.2627 16.4805 20.361C16.6739 20.4592 16.881 20.553 17.102 20.6423ZM20.0992 18.4049C19.6664 18.8247 19.1462 19.0346 18.5385 19.0346C17.9307 19.0346 17.4105 18.8247 16.9777 18.4049C16.545 17.9851 16.3286 17.4805 16.3286 16.891C16.3286 16.3015 16.545 15.7969 16.9777 15.3771C17.4105 14.9573 17.9307 14.7474 18.5385 14.7474C19.1462 14.7474 19.6664 14.9573 20.0992 15.3771C20.532 15.7969 20.7483 16.3015 20.7483 16.891C20.7483 17.4805 20.532 17.9851 20.0992 18.4049Z" fill="#333333"/>\n  '
  }), je.DefineIcon("leftTableAlign", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path d="M18.3333 3V4.33333H1V3H18.3333Z" fill="#999998"/>\n    <path d="M18.3333 15V16.3333H1V15H18.3333Z" fill="#999998"/>\n    <path d="M18.3333 6.45801V7.79134H13V6.45801H18.3333Z" fill="#999998"/>\n    <path d="M18.3333 9.12467V10.458H13V9.12467H18.3333Z" fill="#999998"/>\n    <path d="M18.3333 11.7913V13.1247H13V11.7913H18.3333Z" fill="#999998"/>\n    <path d="M10.3333 12.3333V13.6667H2.33333V12.3333H10.3333ZM10.3333 7H2.33333V13.6667C1.6431 13.6667 1.07495 13.1422 1.00651 12.4701L1 12.3333V7C1 6.26362 1.59695 5.66667 2.33333 5.66667H10.3333C11.0697 5.66667 11.6667 6.26362 11.6667 7V12.3333L11.6602 12.4701C11.5917 13.1422 11.0236 13.6667 10.3333 13.6667V7Z" fill="#333333"/>\n  '
  }), je.DefineIcon("leftTableAlignActive", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path d="M18.8333 3.5V4.83333H1.5V3.5H18.8333Z" fill="#90B7FF"/>\n    <path d="M18.8333 15.5V16.8333H1.5V15.5H18.8333Z" fill="#90B7FF"/>\n    <path d="M18.8333 6.95801V8.29134H13.5V6.95801H18.8333Z" fill="#90B7FF"/>\n    <path d="M18.8333 9.62467V10.958H13.5V9.62467H18.8333Z" fill="#90B7FF"/>\n    <path d="M18.8333 12.2913V13.6247H13.5V12.2913H18.8333Z" fill="#90B7FF"/>\n    <path d="M10.8333 12.8333V14.1667H2.83333V12.8333H10.8333ZM10.8333 7.5H2.83333V14.1667C2.1431 14.1667 1.57495 13.6422 1.50651 12.9701L1.5 12.8333V7.5C1.5 6.76362 2.09695 6.16667 2.83333 6.16667H10.8333C11.5697 6.16667 12.1667 6.76362 12.1667 7.5V12.8333L12.1602 12.9701C12.0917 13.6422 11.5236 14.1667 10.8333 14.1667V7.5Z" fill="#2A77FF"/>\n  '
  }), je.DefineIcon("centerTableAlign", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path d="M18.3333 3V4.33333H1V3H18.3333Z" fill="#999998"/>\n    <path d="M18.3333 15V16.3333H1V15H18.3333Z" fill="#999998"/>\n    <path d="M13 12.3333V13.6667H6.33333V12.3333H13ZM13 7H6.33333V13.6667L6.19661 13.6602C5.56938 13.5963 5.07038 13.0973 5.00651 12.4701L5 12.3333V7C5 6.26362 5.59695 5.66667 6.33333 5.66667H13C13.7364 5.66667 14.3333 6.26362 14.3333 7V12.3333L14.3268 12.4701C14.263 13.0973 13.764 13.5963 13.1367 13.6602L13 13.6667V7Z" fill="#333333"/>\n  '
  }), je.DefineIcon("centerTableAlignActive", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path d="M18.8333 3.5V4.83333H1.5V3.5H18.8333Z" fill="#90B7FF"/>\n    <path d="M18.8333 15.5V16.8333H1.5V15.5H18.8333Z" fill="#90B7FF"/>\n    <path d="M13.5 12.8333V14.1667H6.83333V12.8333H13.5ZM13.5 7.5H6.83333V14.1667L6.69661 14.1602C6.06938 14.0963 5.57038 13.5973 5.50651 12.9701L5.5 12.8333V7.5C5.5 6.76362 6.09695 6.16667 6.83333 6.16667H13.5C14.2364 6.16667 14.8333 6.76362 14.8333 7.5V12.8333L14.8268 12.9701C14.763 13.5973 14.264 14.0963 13.6367 14.1602L13.5 14.1667V7.5Z" fill="#2A77FF"/>\n '
  }), je.DefineIcon("rightTableAlignActive", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path d="M18.8333 3.5V4.83333H1.5V3.5H18.8333Z" fill="#90B7FF"/>\n    <path d="M18.8333 15.5V16.8333H1.5V15.5H18.8333Z" fill="#90B7FF"/>\n    <path d="M6.83333 6.95801V8.29134H1.5V6.95801H6.83333Z" fill="#90B7FF"/>\n    <path d="M6.83333 9.62467V10.958H1.5V9.62467H6.83333Z" fill="#90B7FF"/>\n    <path d="M6.83333 12.2913V13.6247H1.5V12.2913H6.83333Z" fill="#90B7FF"/>\n    <path d="M17.5 12.8333V14.1667H9.5V12.8333H17.5ZM17.5 7.5H9.5V14.1667C8.80976 14.1667 8.24162 13.6422 8.17318 12.9701L8.16667 12.8333V7.5C8.16667 6.76362 8.76362 6.16667 9.5 6.16667H17.5C18.2364 6.16667 18.8333 6.76362 18.8333 7.5V12.8333L18.8268 12.9701C18.7584 13.6422 18.1902 14.1667 17.5 14.1667V7.5Z" fill="#2A77FF"/>\n  '
  }), je.DefineIcon("rightTableAlign", {
    template: "svgMultiplePath",
    viewBox: "0 0 24 24",
    PATHS: '\n    <path d="M18.3333 3V4.33333H1V3H18.3333Z" fill="#999998"/>\n    <path d="M18.3333 15V16.3333H1V15H18.3333Z" fill="#999998"/>\n    <path d="M6.33333 6.45801V7.79134H1V6.45801H6.33333Z" fill="#999998"/>\n    <path d="M6.33333 9.12468V10.458H1V9.12468H6.33333Z" fill="#999998"/>\n    <path d="M6.33333 11.7913V13.1247H1V11.7913H6.33333Z" fill="#999998"/>\n    <path d="M17 12.3333V13.6667H9V12.3333H17ZM17 7H9V13.6667C8.30976 13.6667 7.74162 13.1422 7.67318 12.4701L7.66667 12.3333V7C7.66667 6.26362 8.26362 5.66667 9 5.66667H17C17.7364 5.66667 18.3333 6.26362 18.3333 7V12.3333L18.3268 12.4701C18.2584 13.1422 17.6902 13.6667 17 13.6667V7Z" fill="#333333"/>\n  '
  }), je.DefineIcon("tableSelectorIcon", {
    template: "svgMultiplePath",
    VIEWBOX: "1 1 14 14",
    PATHS: '<mask id="mask0_85_21" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><rect width="16" height="16" fill="white"/></mask>\n          <g mask="url(#mask0_85_21)"><path d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V10H3.33333V12.6667H6V14H3.33333ZM10 \n          14V12.6667H12.6667V10H14V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H10ZM2 6V3.33333C2 2.96667 2.13056 2.65278 2.39167 \n          2.39167C2.65278 2.13056 2.96667 2 3.33333 2H6V3.33333H3.33333V6H2ZM12.6667 6V3.33333H10V2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 \n          14 3.33333V6H12.6667Z" fill="white"/> <rect opacity="0.4" x="4" y="4" width="8" height="8" fill="white"/></g>'
  });
});